// quizzes.js - lesson reinforcement quizzes (Layer 1).
// Schema per item: id, course, lesson_number, topic, q_type, is_free, points,
//   question_az, options{A..D}, correct (shape varies by q_type), explanation.
// Facial items also carry svg_options{A..D}.
// All content is original. No em-dashes in student text.

export const LESSON_QUIZZES = [
  {
    id: 'smt-l1-q1', course: 'smt', lesson_number: 1, topic: 'smt',
    q_type: 'single', is_free: true, points: 1,
    question_az: `Anbar şöbəsində çalışırsınız. Komanda üzvünüz Ramin son iki həftədir gündəlik daşınma qeydlərini natamam təqdim edir. Bəzi sütunlar doldurulmamış qalır. Bu isə digər şöbələrin hesablamalar aparmasını çətinləşdirir. İlk addım kimi ən effektiv davranış hansıdır?`,
    options: {
      A: `Qeydləri özünüz tamamlayın ki, digər şöbələr gecikməsin.`,
      B: `Növbəti ümumi yığıncaqda natamam qeydləri nümunə kimi gündəmə gətirin.`,
      C: `Raminlə təkbətək görüşün, qeydlərin niyə natamam qaldığını birlikdə aydınlaşdırın və konkret düzəliş planı hazırlayın.`,
      D: `Bir müddət gözləyin, çünki problem öz-özünə həll oluna bilər.`,
    },
    correct: 'C',
    explanation: `Burada əsas məsələ görünən nəticəyə deyil, problemin kök səbəbinə yönəlməkdir. Natamam qeydlər problemin görünən tərəfidir. Bunun arxasında tapşırığın aydın olmaması, sistem problemi və ya iş yükü dayana bilər. C variantı səbəbi araşdırır, münasibəti qoruyur və təşəbbüskar addım atır. A variantı problemi müvəqqəti ört-basdır edir, lakin səbəbi aradan qaldırmır. B variantı Ramini ictimai şəkildə utandırır və münasibəti zədələyir. D variantı isə passiv gözləmə mövqeyidir və təşəbbüskar, konstruktiv ünsiyyət prinsipinə uyğun deyil.`,
  },
  {
    id: 'smt-l1-q2', course: 'smt', lesson_number: 1, topic: 'smt',
    q_type: 'single', is_free: true, points: 1,
    question_az: `Maliyyə şöbəsində çalışırsınız. Tərəfdaş təşkilata göndərilən fakturalarda təkrarlanan hesablama xətası aşkar edirsiniz. Xəta hələ ciddi maliyyə təsiri yaratmayıb. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Xətanı aşkar edən kimi müvafiq tərəfə şəffaf şəkildə bildirin və düzəliş planı təklif edin.`,
      B: `Xətanı sənədləşdirin, lakin növbəti rüblük hesabata qədər gözləyin.`,
      C: `Xətanı səssiz şəkildə düzəldin və heç kimi məlumatlandırmayın ki, məsələ böyüməsin.`,
      D: `Məsələni dərhal yuxarı rəhbərliyə ötürün.`,
    },
    correct: 'A',
    explanation: `Problemi erkən, şəffaf və həll yönümlü şəkildə bildirmək təşəbbüskar və konstruktiv yanaşmanın əsasıdır. A variantı bu prinsipə uyğundur. B variantı bildirməni gecikdirir və xətanın daha ciddi nəticələrə səbəb olmasına imkan yaradır. C variantı məlumatı gizlədir və hesabatlılığı zəiflədir. D variantı isə məsələni öz səviyyənizdə həll etmək mümkün olduğu halda eskalasiyaya aparır və səlahiyyətdən düzgün istifadə etmir.`,
  },
  {
    id: 'smt-l1-q3', course: 'smt', lesson_number: 1, topic: 'smt',
    q_type: 'single', is_free: true, points: 1,
    question_az: `Çağrı mərkəzində növbə müdirisiniz. İki operator öz aralarında növbələrini dəyişmək istəyir. Bu dəyişiklik xidmət əhatəsinə mənfi təsir göstərmir və sizin səlahiyyətiniz daxilindədir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Bu cür hər dəyişiklik üçün əvvəlcə rəhbərinizdən icazə alın.`,
      B: `Dəyişikliyə icazə verməyin, çünki iş qrafiki sabit qalmalıdır.`,
      C: `Operatorlara deyin ki, məsələni özləri rəhbərliklə razılaşdırsınlar.`,
      D: `Dəyişikliyin xidmət əhatəsinə təsirini yoxlayın və səlahiyyətiniz daxilindədirsə, təsdiqləyin.`,
    },
    correct: 'D',
    explanation: `Burada əsas məsələ öz səlahiyyət hüdudlarında qalmaqdır. Mövcud səlahiyyətdən istifadə etməmək, onu aşmaq qədər yanlışdır. D variantı səlahiyyətdən düzgün istifadə edir. A variantı sadə qərarı əsassız şəkildə yuxarı səviyyəyə ötürür. B variantı əsassız sərtlikdir. C variantı isə məsuliyyəti operatorların üzərinə ötürür və idarəetmə rolunu yerinə yetirmir.`,
  },
  {
    id: 'smt-l1-q4', course: 'smt', lesson_number: 1, topic: 'smt',
    q_type: 'dual', is_free: true, points: 1,
    question_az: `Marketinq komandasında çalışırsınız. Daha az təcrübəli həmkarınız Aytən yığıncaqda qərarınızı hamının qarşısında şübhə altına aldı, lakin bunu kobud tonda etmədi. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Yığıncaqdan sonra Aytənlə təkbətək danışın, fikrini diqqətlə dinləyin və qərarın əsaslandırmasını izah edin.`,
      B: `Heç nə etməyin, çünki məsələ zamanla unudular.`,
      C: `Yığıncaq zamanı Aytəni dayandırın və hamının qarşısında səhv etdiyini bildirin.`,
      D: `Aytənin keçmiş rəhbərinə bu davranış barədə şikayət edin.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `İki seçim formatında həm ən yaxşı, həm də ən zəif variant müəyyən edilməlidir. A variantı münasibəti qoruyur, aktiv dinləmə vasitəsilə Aytənin narahatlığını anlamağa imkan verir və buna görə ən effektiv seçimdir. C variantı onu ictimai şəkildə utandıra, müdafiə mövqeyinə çəkə və komanda mühitini zədələyə bilər. Buna görə C ən az effektiv seçimdir. B variantı passiv yanaşmadır, D variantı isə münasibətə dolayı şəkildə zərər verə bilər. Lakin onların heç biri C qədər zərərli deyil.`,
  },
  {
    id: 'smt-l1-q5', course: 'smt', lesson_number: 1, topic: 'smt',
    q_type: 'ranking', is_free: true, points: 1,
    question_az: `Sabah rəhbərliyə təqdim ediləcək aylıq hesabatı hazırlayan əsas işçi bu gün xəstələnib və işə çıxa bilməyəcəyini bildirib. Hesabatın bir hissəsi hazırdır, qalan hissəsi yarımçıqdır. Aşağıdakı davranışları ən effektivdən ən az effektivə doğru sıralayın.`,
    options: {
      A: `Heç bir əlavə addım atmadan işçinin sabaha qədər sağalıb işə çıxacağını gözləyin.`,
      B: `Hesabatı tamamilə ləğv edin və gecikmənin səbəbinin xəstələnən işçi olduğunu rəhbərliyə bildirin.`,
      C: `İşçi ilə qısa əlaqə saxlayıb hesabatın hansı hissəsinin hazır, hansının yarımçıq olduğunu dəqiqləşdirin, sonra qalan işi komanda arasında real plana uyğun bölüşdürün.`,
      D: `Komandadan hazır hissəni təqdim edib qalanını qeyd edən ehtiyat variantı hazırlamağı xahiş edin və eyni zamanda işçi ilə əlaqəni saxlayın.`,
    },
    correct: ['C', 'D', 'A', 'B'],
    explanation: `Sıralama formatında variantların bir-biri ilə müqayisəsi vacibdir. C variantı vəziyyəti dəqiqləşdirib qalan işi real plana uyğun bölüşdürdüyü üçün ən effektiv seçimdir. D variantı paralel ehtiyat variantı hazırladığı üçün ikinci ən effektiv seçimdir. A variantı passivdir, lakin dərhal əlavə zərər yaratmır. B variantı isə həm həddindən artıq reaksiya, həm də açıq ittiham xarakteri daşıyır. Bu yanaşma münasibətlərə və nüfuza zərər verə bilər. Buna görə ən az effektiv seçimdir.`,
  },
  {
    id: 'smt-l1-q6', course: 'smt', lesson_number: 1, topic: 'smt',
    q_type: 'likert', is_free: true, points: 1,
    question_az: `Dizayn studiyasında çalışırsınız. Komanda üzvünüz Səbinə son həftələrdə daha susqun görünür və əvvəlki qədər təşəbbüs göstərmir. Aşağıdakı davranışların hər birini effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin.`,
    options: {
      A: `Səbinə ilə təkbətək söhbət edin, son vaxtlar özünü necə hiss etdiyini soruşun və onu diqqətlə dinləyin.`,
      B: `Onun iş yükünü və tapşırıqlarının nə dərəcədə aydın olduğunu yoxlayın. Problem bununla bağlıdırsa, uyğun düzəlişlər edin.`,
      C: `Komanda yığıncağında onun məhsuldarlığının azaldığını qeyd edin.`,
      D: `Bir müddət müşahidə edin və dəyişiklik olmasa, sonra onunla söhbət edin.`,
    },
    correct: { A: 4, B: 3, C: 1, D: 2 },
    explanation: `Şkala formatında variantlar bir-birindən asılı olmadan qiymətləndirilir. A variantı kök səbəbi birbaşa araşdırmağa imkan verir və münasibəti qoruyur. Buna görə 4 balla qiymətləndirilir. B variantı mümkün struktur səbəbi yoxladığı üçün faydalıdır və 3 balla qiymətləndirilir. D variantı müdaxiləni gecikdirir, lakin tamamilə passiv yanaşma deyil. Buna görə 2 balla qiymətləndirilir. C variantı isə şəxsi məsələni ictimailəşdirir və münasibəti zədələyir. Buna görə 1 balla qiymətləndirilir.`,
  },
  {
    id: 'smt-l2-q1', course: 'smt', lesson_number: 2, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Tərcümə bürosunda komanda üzvünüz Pərviz vacib bir sənədi vaxtında çatdıra bilməyəcəyini bildirir və çox narahatdır. Aşağıdakılardan hansı empatiya tələsinə düşmədən ən effektiv davranışdır?`,
    options: {
      A: `Pərvizə anlayış göstərin və son tarixi uzatmağa çalışın, çünki o çətin vəziyyətdədir.`,
      B: `Sənədi başqa tərcüməçiyə verin, çünki vaxt itirmək olmaz.`,
      C: `Pərvizlə birlikdə konkret maneəni aydınlaşdırın, sənədi vaxtında çatdırmaq üçün nə lazım olduğunu müəyyən edin və zərurət yaranarsa, əlavə resurs cəlb edin.`,
      D: `Rəhbərinizə bildirin ki, son tarix uzadılsın.`,
    },
    correct: 'C',
    explanation: `Empatiya tələsi iştirakçını insana yaxşı təsir bağışlayan, lakin problemi həll etməyən seçimə yönəldə bilər. Yoxlama sualı belədir: bu seçim problemi həll edir, yoxsa yalnız Pərvizin özünü daha yaxşı hiss etməsinə xidmət edir? A variantı yalnız emosional dəstək göstərir. B qətilik tələsidir, səbəbi aydınlaşdırmadan tapşırığı başqasına ötürür. D eskalasiya tələsidir. C variantı kök səbəbi araşdırır və həll yönümlü addım təklif edir.`,
  },
  {
    id: 'smt-l2-q2', course: 'smt', lesson_number: 2, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Kitab nəşriyyatında redaktorlar komandasına rəhbərlik edirsiniz. Bir kitabın çapa verilməsinə üç gün qalıb, lakin son oxunuş zamanı problem üzə çıxır. İlk reaksiyanız dərhal qərar verməkdir. Tələskənlik tələsindən qaçmaq üçün ən effektiv davranış hansıdır?`,
    options: {
      A: `Problemi qısaca müəyyənləşdirin, real təsirini qiymətləndirin və ona uyğun addım atın.`,
      B: `İlk ağlınıza gələn həlli dərhal tətbiq edin, çünki vaxt azdır.`,
      C: `Çapı dayandırıb bütün prosesi yenidən başladın.`,
      D: `Problemi görməzdən gəlin, çünki düzəliş vaxt aparır.`,
    },
    correct: 'A',
    explanation: `Tələskənlik tələsi vaxt təzyiqi altında kök səbəb araşdırılmadan addım atmağa sövq edir. Yoxlama sualı belədir: tez hərəkət həqiqətən tələb olunur, yoxsa sadəcə belə təsir bağışlayır? A variantı əvvəlcə problemi aydınlaşdırır, sonra ölçülü reaksiya göstərir. B variantı məhz bu tələyə düşməyi göstərir. C variantı həddindən artıq reaksiyadır. D variantı problemi inkar edir, təşəbbüskarlığa ziddir.`,
  },
  {
    id: 'smt-l2-q3', course: 'smt', lesson_number: 2, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bələdiyyənin su təsərrüfatı xidmətində sahə rəhbərisiniz. Komandanızda kiçik koordinasiya problemi yaranıb və siz bu məsələni öz səviyyənizdə həll edə bilərsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Məsələni dərhal yuxarı rəhbərliyə ötürün ki, qərarı onlar versin.`,
      B: `Problemi yazılı şəkildə sənədləşdirin və rəhbərə hesabat göndərin.`,
      C: `Gözləyin, bəlkə komanda özü həll edər.`,
      D: `Problemi həll etmək üçün lazımi məlumat və səlahiyyətinizin olduğunu yoxlayın və özünüz müdaxilə edin.`,
    },
    correct: 'D',
    explanation: `Burada eskalasiya və iyerarxiya tələləri yoxlanılır. Hər çətin məsələni yuxarı səviyyəyə ötürmək idarəetmə qabiliyyətini sual altına qoyur. Yoxlama sualı belədir: bu problemi öz səviyyəmdə həll edə bilərəmmi? Cavab müsbət olduğuna görə D variantı doğrudur. A və B variantları eskalasiya tələsinə əsaslanır, problemi həll etmir, məsələni başqa səviyyəyə ötürür. C variantı passiv yanaşmadır.`,
  },
  {
    id: 'smt-l2-q4', course: 'smt', lesson_number: 2, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Layihə komandasında bir üzvün davranışı sizi narahat edir. Şəffaflıq məqsədilə onu komanda qarşısında açıq müzakirəyə çıxarmağı düşünürsünüz. Şəffaflıq tələsindən qaçmaq üçün ən effektiv davranış hansıdır?`,
    options: {
      A: `Məsələni növbəti komanda yığıncağında açıq müzakirəyə çıxarın ki, hər kəs xəbərdar olsun.`,
      B: `Həmin şəxsə kənarda, təkbətək müraciət edin və narahatlığınızı konkret fakt əsasında bildirin.`,
      C: `Heç nə deməyin, çünki açıq danışmaq münaqişə yarada bilər.`,
      D: `Digər komanda üzvlərindən həmin şəxs barədə fikir toplayın.`,
    },
    correct: 'B',
    explanation: `Şəffaflıq tələsi ictimai ifşanı şəffaflıqla qarışdırır. Yoxlama sualı belədir: bu açıqlıq problemi həll etmək üçündür, yoxsa kimisə cavabdeh göstərmək üçün? B variantı şəffaflığı düzgün formada, yəni birbaşa və konkret fakt əsasında tətbiq edir. A variantı ictimai ifşadır, münasibəti zədələyir. C variantı münaqişədən qaçmaqdır. D variantı arxa planda fikir toplamaqla etibarı sarsıdır.`,
  },
  {
    id: 'smt-l2-q5', course: 'smt', lesson_number: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Hesabat hazırlayan kiçik bir komandada bir üzv qəfildən xəstələnir və ona aid hissə yarımçıq qalır. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Bütün komanda üçün əlavə iş saatları təyin edin, səbəbini izah etmədən.`,
      B: `Yarımçıq hissənin vəziyyətini qiymətləndirin, qalan resursları və mövcud vaxtı nəzərdən keçirin, sonra işi real icra planı üzrə yenidən bölüşdürün.`,
      C: `Rəhbərə bildirin ki, hesabatın ümumi son tarixi uzadılsın.`,
      D: `Heç nə dəyişdirməyin, xəstə komanda üzvü qayıdana qədər gözləyin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `B variantı kök səbəbi (resurs çatışmazlığı) qiymətləndirir və ölçülü plan qurur, ən effektivdir. D variantı passiv gözləmədir və son tarixi riskə atır, ən az effektivdir. A variantı izahsız təzyiq münasibəti zədələyir, C variantı isə öz səviyyənizdə həll mümkün ikən eskalasiyaya keçir. Hər ikisi zəifdir, lakin D qədər passiv deyil.`,
  },
  {
    id: 'smt-l2-q6', course: 'smt', lesson_number: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Komanda üzvünüz yaxşı bir tapşırığı yenicə tamamlayıb. Aşağıdakı davranışları ən effektivdən ən az effektivə doğru sıralayın.`,
    options: {
      A: `Nəyi yaxşı etdiyini konkret qeyd edərək onun əməyini vaxtında tanıyın.`,
      B: `Heç nə deməyin, çünki işin yaxşı olması artıq gözlənilən nəticədir.`,
      C: `Tanımanı növbəti illik qiymətləndirməyə saxlayın.`,
      D: `Ümumi şəkildə "afərin" deyin, lakin bunun nəyə görə olduğunu qeyd etməyin.`,
    },
    correct: ['A', 'D', 'C', 'B'],
    explanation: `Əməyin tanınması güclü motivasiya siqnallarından biridir, xüsusilə konkret davranışa bağlı olduqda. A variantı konkret və vaxtındadır (ən effektiv). D variantı əməyin tanınmasını təmin edir, lakin konkretlik yoxdur. C əməyin tanınmasını lazımsız yerə gecikdirir. B variantı isə əməyin tanınmasını tamamilə inkar edir, əməyin tanınmasını gecikdirmək tələsinin ən kəskin formasıdır (ən az effektiv).`,
  },
  {
    id: 'smt-l3-q1', course: 'smt', lesson_number: 3, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Apteklər şəbəkəsində regional koordinatorsunuz. Sabah qərar verilməli olan bir məsələ var, lakin əlinizdə məlumatın yalnız 80 faizi mövcuddur. Qalanı bir həftə sonra gələcək. Qərarın gecikdirilməsi xəstələrin təchizatını poza bilər. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Bütün məlumat gələnə qədər qərarı bir həftə təxirə salın.`,
      B: `Qərarı rəhbərinizə ötürün, çünki məlumat tam deyil.`,
      C: `Mövcud kifayət qədər məlumat əsasında qərar verin, riskləri qeyd edin və yeni məlumat daxil olduqda qərara yenidən baxmağı planlaşdırın.`,
      D: `Təsadüfi bir variant seçin, çünki fərq əhəmiyyətli deyil.`,
    },
    correct: 'C',
    explanation: `Düzgün yanaşma kifayət qədər məlumat əsasında hərəkət etmək, mükəmməl məlumatı gözləməməkdir. C variantı kifayət qədər məlumat əsasında hərəkət etməyi nəzərdə tutur və qərara yenidən baxış mexanizmi yaradır. A variantı tam məlumatı gözləyərək təchizatın pozulmasına səbəb ola bilər. B variantı eskalasiya refleksidir, qərar sizin səlahiyyətinizdədir. D variantı məsuliyyətsiz və təsadüfi qərardır.`,
  },
  {
    id: 'smt-l3-q2', course: 'smt', lesson_number: 3, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Universitetin qeydiyyat şöbəsində bir prosesin tamamilə ləğv edilərək yenisi ilə əvəz olunması təklif edilir. Sonradan əvvəlki prosesə qayıtmaq çox çətin olacaq. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Nəticələri çətin dəyişdirilən qərar qəbul etməzdən əvvəl təsiri diqqətlə qiymətləndirin, mümkün olduqda, kiçik miqyasda sınaqdan keçirin.`,
      B: `Dərhal köhnə prosesi ləğv edin, çünki yenisi daha yaxşı görünür.`,
      C: `Qərarı qeyri-müəyyən müddətə təxirə salın.`,
      D: `Qərarı işçilərin səsverməsinə buraxın.`,
    },
    correct: 'A',
    explanation: `Nəticələri çətin dəyişdirilən qərarları ehtiyatla qəbul etmək lazımdır. A variantı təsiri qiymətləndirir və kiçik miqyaslı sınaq vasitəsilə riski azaldır. B variantı düzəldilməsi çətin nəticələr yaradan addımı yoxlama aparmadan atır. C variantı passiv gecikdirmədir. D variantı məsuliyyəti yersiz şəkildə başqalarına ötürür. Qiymətləndirmə rəhbərin məsuliyyətidir.`,
  },
  {
    id: 'smt-l3-q3', course: 'smt', lesson_number: 3, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Sığorta şirkətində qrup rəhbərisiniz. Çətin müştəri məsələsi yaranıb. İlkin reaksiya olaraq məsələni dərhal yuxarı rəhbərliyə ötürmək istəyirsiniz, lakin məsələ sizin səlahiyyətiniz və bilik dairəniz daxilindədir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Məsələni dərhal rəhbərliyə ötürün, çünki çətindir.`,
      B: `Məsələni başqa qrupa yönləndirin.`,
      C: `Heç nə etmədən müştərinin sakitləşməsini gözləyin.`,
      D: `Məsələni öz səviyyənizdə həll etməyə çalışın. Yalnız bu cəhd nəticəsiz qalsa və ya məsələ səlahiyyətinizi aşsa, eskalasiya edin.`,
    },
    correct: 'D',
    explanation: `Eskalasiya birinci deyil, adətən ikinci addımdır. D variantı əvvəlcə məsələni öz səviyyənizdə həll etməyi nəzərdə tutur, eskalasiyanı yalnız zəruri hallar üçün saxlayır. A variantı eskalasiya refleksidir və idarəetmə məsuliyyətindən yayınma təsiri bağışlaya bilər. C variantı passiv yanaşmadır. B variantı məsuliyyəti başqa qrupa ötürür.`,
  },
  {
    id: 'smt-l3-q4', course: 'smt', lesson_number: 3, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Restoran zəncirində filiallardan birində gözlənilməz nasazlıq yaranıb və tez qərar verilməsi tələb olunur. Tez qərar verməklə tələsik qərar vermək arasındakı fərqi nəzərə alaraq ən effektiv davranış hansıdır?`,
    options: {
      A: `İlk ağla gələn həlli dərhal tətbiq edin, çünki vaxt azdır.`,
      B: `Vəziyyəti qısaca qiymətləndirin, əsas faktları yoxlayın və ən əsaslı görünən variantı tez, lakin əsaslı şəkildə seçin.`,
      C: `Qərarı növbəti günə saxlayın ki, hər şeyi araşdırasınız.`,
      D: `Bütün işçiləri toplayıb uzun müzakirə açın.`,
    },
    correct: 'B',
    explanation: `Tez qərar verməklə tələsik qərar vermək fərqli anlayışlardır. B variantı sürətli yanaşmadır, lakin əsas faktlar yoxlanır, yəni həm tez, həm də əsaslıdır. A variantı tələsik yanaşmadır, faktları yoxlamır. C variantı lazımsız ləngimədir, problemi daha da dərinləşdirə bilər. D variantında vaxt təzyiqi şəraitində uzun müzakirə aparmaq effektiv deyil.`,
  },
  {
    id: 'smt-l3-q5', course: 'smt', lesson_number: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Tədarüklə bağlı qərar verməlisiniz. İki məlumat mənbəyi bir-biri ilə ziddiyyət təşkil edir. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `İlk gözünüzə dəyən mənbəni seçin, ziddiyyəti araşdırmadan qərar verin.`,
      B: `Hər iki mənbəni nəzərə alıb ortalama bir qərar verin, baxmayaraq ki, bu məntiqsizdir.`,
      C: `Ziddiyyətin səbəbini qısaca yoxlayın, daha etibarlı mənbəni müəyyən edin və ona əsasən qərar verin.`,
      D: `Hər iki mənbəni etibarsız sayıb qərarı tamamilə təxirə salın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `C variantı ziddiyyəti yoxlayaraq kifayət qədər məlumat əsasında əsaslı qərar verməyi nəzərdə tutur (ən effektiv). A variantı fərziyyəni faktlardan ayırmır, ziddiyyəti göz ardı edir (ən az effektiv). B variantı məntiqsiz orta yanaşmaya əsaslandığı üçün yanlışdır, D variantı isə qərarı lazımsız yerə təxirə salır. Lakin A ən risklidir, çünki səhv mənbəyə əsaslana bilər.`,
  },
  {
    id: 'smt-l3-q6', course: 'smt', lesson_number: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Vaxt məhduddur, məlumat isə natamamdır, lakin qərar bu gün verilməlidir. Aşağıdakı davranışları ən effektivdən ən az effektivə doğru sıralayın.`,
    options: {
      A: `Qərarı təsadüfən verin, çünki məlumat tam deyil.`,
      B: `Kafi məlumatla qərar verin, əsas riskləri qeyd edin və yenidən baxış nöqtəsi təyin edin.`,
      C: `Bütün məlumatı gözləyin, son tarixi keçirmək bahasına olsa belə.`,
      D: `Mövcud məlumatla qərar verin, lakin riskləri nəzərə almayın.`,
    },
    correct: ['B', 'D', 'C', 'A'],
    explanation: `B variantı kifayət qədər məlumat əsasında hərəkət edir və riskləri idarə edir (ən effektiv). D variantı hərəkət edir, lakin riskləri qiymətləndirmir, buna görə ikinci yerdədir. C variantı tam məlumatı gözləyərək son tarixin pozulmasına səbəb olur. A variantı isə tamamilə əsassız və təsadüfi qərardır (ən az effektiv).`,
  },
  {
    id: 'smt-l4-q1', course: 'smt', lesson_number: 4, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Elektrik şəbəkəsinin monitorinq mərkəzində çalışırsınız. Bir rayondan daxil olan nasazlıq bildirişləri bir gün ərzində kəskin artıb. Komanda üzvünüz Kənan dərhal deyir ki, transformatorun sıradan çıxdığını. İlk addım kimi ən effektiv davranış hansıdır?`,
    options: {
      A: `Nəticə çıxarmazdan əvvəl bildirişlərin mənbəyini, vaxtını və digər mümkün səbəbləri yoxlayın.`,
      B: `Kənanın fikrinə əsaslanıb dərhal transformatoru dəyişdirin.`,
      C: `Bildirişləri nəzərə almayın, çünki bir rayon ümumi şəbəkəyə təsir etməz.`,
      D: `Problemi dərhal rəhbərliyə ötürün ki, qərarı onlar qəbul etsin.`,
    },
    correct: 'A',
    explanation: `Analitik təhlildə fərziyyəni faktlardan ayırmaq əsasdır. A məlumatı yoxlayır və alternativ izahları (sayğac xətası, hava şəraiti, kütləvi tədbir) nəzərdən keçirir, ilk izahı tələsik qəbul etmir. B ilk izahı faktlarla yoxlamadan qəbul edir, bu, ən tipik analitik tələdir. C aydın siqnalı görməzdən gəlir. D öz səviyyənizdə təhlil mümkün ikən vaxtından əvvəl eskalasiyadır.`,
  },
  {
    id: 'smt-l4-q2', course: 'smt', lesson_number: 4, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Aptek şəbəkəsində bir məhsulun satışı keçən ay bir filialda kəskin düşüb. Səbəbi araşdırarkən ən effektiv ilk addım hansıdır?`,
    options: {
      A: `Məhsulun reklamını dərhal artırın, çünki satış aşağıdır.`,
      B: `Rəqəmin doğru qeydə alındığını və digər filiallarla müqayisəni yoxlayın.`,
      C: `Məhsulu rəfdən çıxarın, çünki müştəri marağı itib.`,
      D: `Satıcını məsul tutun, çünki düşüş onun növbəsində baş verib.`,
    },
    correct: 'B',
    explanation: `Nəticə çıxarmadan əvvəl məlumatın etibarlılığını yoxlamaq lazımdır. B variantı əvvəlcə məlumatın düzgünlüyünü (qeyd xətası, anbar problemi) və müqayisə bazasını araşdırır. A və C variantları səbəbi anlamadan tələsik addımdır. D variantı təsdiq qərəzidir, bir nəfəri faktlarla əsaslandırmadan məsul tutur.`,
  },
  {
    id: 'smt-l4-q3', course: 'smt', lesson_number: 4, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `İdman klubunda son həftələrdə üzv şikayətləri artıb. Rəhbəriniz "yəqin səbəb yeni məşqçidir" deyir. Analitik baxımdan ən düzgün davranış hansıdır?`,
    options: {
      A: `Yeni məşqçi ilə dərhal söhbət edin və ona xəbərdarlıq edin.`,
      B: `Şikayətləri nəzərə almayın, çünki hər zaman narazı olanlar olur.`,
      C: `Şikayətlərin nə vaxt, hansı mövzuda və kimə aid olduğunu ayırıb fərziyyəni dəlillə yoxlayın.`,
      D: `Bütün məşqçilərə eyni töhmət verin ki, məsələ tez həll olsun.`,
    },
    correct: 'C',
    explanation: `Fərziyyəni faktlardan ayırmaq prinsipi. C variantı şikayətləri strukturlaşdırır və "yeni məşqçi" fərziyyəsini faktiki məlumat əsasında yoxlayır, başqa izahlara da (cədvəl dəyişikliyi, avadanlıq) yer saxlayır. A variantı təsdiqlənməmiş fərziyyə əsasında intizam tədbiri görür. B variantı məlumatı görməzdən gəlir. D variantı ümumi və ədalətsiz reaksiyadır.`,
  },
  {
    id: 'smt-l4-q4', course: 'smt', lesson_number: 4, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Onlayn çatdırılma platformasında bir şəhərdə müştəri reytinqi son həftə aşağı düşüb. Komanda dərhal "kuryerlər pisdir" qənaətinə gəlir. Ən effektiv analitik yanaşma hansıdır?`,
    options: {
      A: `Kuryerlərə cərimə tətbiq edin ki, reytinq qalxsın.`,
      B: `Reytinqi gizlədin ki, mənfi təsir yayılmasın.`,
      C: `Yalnız bu izaha uyğun məlumatı toplayın ki, fərziyyə təsdiqlənsin.`,
      D: `Bir neçə mümkün səbəbi (hava, tətbiq nasazlığı, sifariş artımı, yeni ərazi) ayrıca yoxlayıb müqayisə edin.`,
    },
    correct: 'D',
    explanation: `Alternativ izahları nəzərdən keçirmək və təsdiq qərəzindən qaçmaq prinsipi. D variantı müxtəlif izahları sistemli şəkildə yoxlayır. A variantı səbəbi aydınlaşdırmadan cəza tətbiq edir. B variantı problemi gizlədir. C variantı təsdiq qərəzidir: yalnız fərziyyəni dəstəkləyən məlumatı seçmək təhlilin obyektivliyini pozur.`,
  },
  {
    id: 'smt-l4-q5', course: 'smt', lesson_number: 4, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bir təlim proqramının nəticələri qruplar arasında çox fərqlənir. Səbəbi başa düşmək istəyirsiniz. Aşağıdakı yanaşmalardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Qrupların başlanğıc səviyyəsi, müəllim və müddət kimi amilləri nəzərə alaraq strukturlaşdırılmış müqayisə aparın.`,
      B: `Yalnız ən zəif qrupun rəhbəri ilə danışıb ümumi nəticə çıxarın.`,
      C: `Bir iştirakçının təsadüfi rəyinə əsaslanıb bütün proqramı dəyişin.`,
      D: `Nəticələri qruplar üzrə cədvələ salıb fərqlərin harada yarandığını axtarın.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Burada məlumatı strukturlaşdırılmış şəkildə qiymətləndirmək tələb olunur. A variantı ən effektivdir: dəyişənləri nəzarətdə tutub müqayisə edir, qərəzi azaldır. C variantı ən az effektivdir: bir təsadüfi rəy əsasında ümumi qərar çıxarmaq tipik nümunə qərəzidir. B variantı məhdud mənbəyə əsaslanır, D variantı faydalı ilk addımdır, lakin A qədər tam deyil.`,
  },
  {
    id: 'smt-l4-q6', course: 'smt', lesson_number: 4, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Gözlənilməz anomaliyanı (məsələn, anbar uçotunda izahsız fərq) araşdırırsınız. Aşağıdakı addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk ağlınıza gələn izahı doğru sayıb işi bağlayın.`,
      B: `Sualı dəqiqləşdirin və mövcud məlumatı toplayın.`,
      C: `Bir neçə mümkün izah qurub hər birini dəlillə yoxlayın.`,
      D: `Ən çox dəstəklənən izahı seçib təsdiq üçün əlavə dəlil axtarın.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `Strukturlaşdırılmış analitik proses: əvvəlcə B sualı və məlumatı aydınlaşdırır, sonra C alternativ izahları yoxlayır, sonra D ən güclü izahı əlavə faktlarla möhkəmləndirir. A ən az effektivdir, çünki ilk izaha tələsmək analitik təhlilin əsas tələlərindən biridir.`,
  },
  {
    id: 'smt-l5-q1', course: 'smt', lesson_number: 5, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bələdiyyənin parklar şöbəsində eyni gün çox sayda tapşırıq toplanıb: bəziləri təcili, bəziləri uzunmüddətli baxımdan əhəmiyyətli. Vaxt məhduddur. Ən effektiv planlaşdırma hansıdır?`,
    options: {
      A: `Tapşırıqları əhəmiyyət və təcililik üzrə qiymətləndirib prioritet sırası qurun.`,
      B: `Ən çox təkid edən şəxsin işini birinci icra edin.`,
      C: `Tapşırıqları gəldiyi ardıcıllıqla hər tapşırığı icra edin.`,
      D: `Yalnız asan tapşırıqları seçin ki, siyahı tez qısalsın.`,
    },
    correct: 'A',
    explanation: `Vaciblik və təcililik prinsipi. A variantı tapşırıqları iki ölçü üzrə qiymətləndirib şüurlu prioritet qurur. B variantı təzyiqə görə qərar verir, əhəmiyyəti nəzərə almır. C variantı kortəbii yanaşmadır. D variantı yalnız rahatlığı seçir, vacib işləri təxirə salır.`,
  },
  {
    id: 'smt-l5-q2', course: 'smt', lesson_number: 5, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Mətbəədə bir tapşırığı komanda üzvünə həvalə edirsiniz. Ən effektiv həvaləetmə hansıdır?`,
    options: {
      A: `Tapşırığı təsadüfi olaraq bir komanda üzvünə verin, çünki hamı eyni işi görə bilər.`,
      B: `Tapşırığı bacarığı və inkişaf ehtiyacı tapşırığa uyğun gələn şəxsə verin, konteksti və səlahiyyəti aydın izah edin.`,
      C: `Tapşırığı özünüz görün, çünki başqasına etibar etmək riskdir.`,
      D: `Tapşırığı verib heç bir kontekst və ya səlahiyyət vermədən nəticə gözləyin.`,
    },
    correct: 'B',
    explanation: `Həvaləetmə tapşırığı bacarığa uyğunlaşdırmaqdır; sadəcə işi başqasının üzərinə ötürmək deyil. B variantı icraçını düzgün seçir, kontekst və səlahiyyət verir. A variantı təsadüfi seçimdir. C variantı həvaləetmədən imtinadır və komandanı inkişaf etdirmir. D variantı səlahiyyətsiz tapşırıq verməkdir, uğursuzluq riski yaradır.`,
  },
  {
    id: 'smt-l5-q3', course: 'smt', lesson_number: 5, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Layihədə resursların gözləniləndən az olduğu məlum olub və hər şeyi vaxtında bitirmək mümkün deyil. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Komandadan əlavə saatlar tələb edib bütün işləri bitirməyə çalışın.`,
      B: `Heç nəyi dəyişmədən davam edin, bəlkə vaxt çatar.`,
      C: `Məqsədlərə əsaslanaraq nəyin təxirə salınacağını şəffaf qərarlaşdırın və aidiyyəti tərəfləri xəbərdar edin.`,
      D: `Bütün işləri yarımçıq paralel aparın ki, heç biri dayanmasın.`,
    },
    correct: 'C',
    explanation: `Resurs çatışmazlığında prinsip: nəyin kənara qoyulacağını şüurlu seçmək. C variantı məqsədə görə prioritet verir və şəffaf ünsiyyət qurur. A variantı münasibəti və keyfiyyəti riskə atır. B variantı passiv gözləmə mövqeyidir. D variantı diqqəti dağıdır, heç bir işi tamamlamağa imkan vermir.`,
  },
  {
    id: 'smt-l5-q4', course: 'smt', lesson_number: 5, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Komanda üzvünüzə mühüm tapşırıq həvalə etmisiniz. İşin gedişini izləmək istəyirsiniz. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Razılaşdırılmış aralıq yoxlama nöqtələri təyin edin və lazım olduqda dəstək verin.`,
      B: `Hər saat işin düzgün gedib-getmədiyini soruşun.`,
      C: `Heç soruşmayın, nəticəni son tarixdə görərsiniz.`,
      D: `İşi gizlicə özünüz təkrar yoxlayıb düzəldin.`,
    },
    correct: 'A',
    explanation: `Nəzarətin həddindən artıq nəzarət olmaması prinsipi. A variantı aralıq yoxlama nöqtələri qoyur, bu, həm şəffaflıq, həm müstəqillik verir. B variantı həddindən artıq nəzarətdir, etibarı zədələyir. C variantı nəzarətsizlikdir, riski gec aşkar edir. D variantı gizli düzəliş həm vaxt itkisi, həm inkişafa mane olur.`,
  },
  {
    id: 'smt-l5-q5', course: 'smt', lesson_number: 5, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Qısa müddətdə tamamlanmalı yeni bir layihəni planlaşdırırsınız. Aşağıdakılardan ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Komandanın tutumunu qiymətləndirmədən bütün işləri vaxtında tamamlayacağınıza söz verin.`,
      B: `Prioritetləri, mərhələləri və ehtiyat vaxtını nəzərə alan real plan qurun.`,
      C: `Yalnız ən rahat gördüyünüz hissələri planlaşdırın, qalanını sonraya saxlayın.`,
      D: `Planı ümumi cümlələrlə qurun, detalları iş prosesində həll edərsiniz.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Real planlaşdırma prinsipi. B ən effektivdir: prioritet, mərhələ və ehtiyat vaxtı ilə icrası mümkün olan plan qurur. A variantı ən az effektivdir: komandanın tutumunu qiymətləndirmədən söz vermək gözlənti uyğunsuzluğu və münasibət riski yaradır. C natamam əhatə yanaşmasıdır, D isə icra üçün çox qeyri-müəyyəndir.`,
  },
  {
    id: 'smt-l5-q6', course: 'smt', lesson_number: 5, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Yeni bir təşkilati tapşırığı planlaşdırırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İşə başlayıb detalları prosesin gedişində həll edin.`,
      B: `Tapşırıqları resurs və bacarığa uyğun bölüşdürün.`,
      C: `Aralıq yoxlama nöqtələri ilə icranı izləyin.`,
      D: `Məqsədi və prioritetləri aydınlaşdırın.`,
    },
    correct: ['D', 'B', 'C', 'A'],
    explanation: `Planlaşdırma ardıcıllığı: əvvəlcə D məqsəd və prioritet, sonra B resurs və bacarığa uyğun bölüşdürmə, sonra C nəzarət nöqtələri. A ən az effektivdir, çünki məqsəd və plan olmadan başlamaq sonradan ciddi düzəliş ehtiyacı yaradır.`,
  },
  {
    id: 'smt-l6-q1', course: 'smt', lesson_number: 6, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Diş klinikasının qəbul şöbəsində işləyirsiniz. Həmkarınız Fidanın iş üsulunda təkmilləşdirilməsi lazım olan bir məqam görürsünüz. Ən effektiv rəy hansıdır?`,
    options: {
      A: `"Sən diqqətsizsən" deyin ki, mesaj aydın olsun.`,
      B: `Heç nə deməyin, vaxtla özü düzələr.`,
      C: `Konkret bir hadisəyə, davranışa və onun nəticəsinə əsaslanan rəy verin.`,
      D: `Rəyinizi başqalarının yanında bildirin ki, daha təsirli olsun.`,
    },
    correct: 'C',
    explanation: `Rəy konkret, davranış əsaslı və nəticə yönümlü olmalıdır. C variantı bu prinsipə uyğundur. A variantı şəxsiyyətə hücumdur, davranışı göstərmir. B variantı problemi həll etmir. D variantı ictimai tənqid münasibəti zədələyir və müdafiə reaksiyası yaradır.`,
  },
  {
    id: 'smt-l6-q2', course: 'smt', lesson_number: 6, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Radio stansiyasında komanda üzvü Samir son vaxtlar dəfələrlə gecikir və bu, efir hazırlığına təsir edir. Onunla söhbəti necə başlamaq ən effektivdir?`,
    options: {
      A: `"Sən məsuliyyətsizsən" deyə başlayın.`,
      B: `Söhbətdən qaçıb cədvəli özünüz düzəldin.`,
      C: `Onu komanda yığıncağında nümunə kimi göstərin.`,
      D: `Müşahidə etdiyiniz konkret faktı qeyd edib təsirini izah edin, sonra səbəbi soruşun.`,
    },
    correct: 'D',
    explanation: `Çətin söhbət ittihamla deyil, faktla başlamalıdır. D variantı müşahidəni və təsirini bildirir, sonra dinləyir. A variantı ittihamla başlayır, müdafiə mövqeyinə keçirir. B variantı problemi gizlədir. C variantı ictimai şəkildə utandırmadır, münasibəti pozur.`,
  },
  {
    id: 'smt-l6-q3', course: 'smt', lesson_number: 6, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Mebel emalatxanasında rəhbərinizin verdiyi göstəriş sizin üçün qismən qeyri-aydındır və yanlış başa düşdüyünüz halda, material itkisi ola bilər. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Aydın olmayan məqamı erkən, şəffaf və həll yönümlü şəkildə rəhbərinizlə dəqiqləşdirin.`,
      B: `Öz təxmininizlə işə başlayın ki, sual verməklə narahatlıq yaratmayasınız.`,
      C: `İşi təxirə salıb gözləyin, bəlkə rəhbər özü izah edər.`,
      D: `Həmkarlarınıza şikayət edin ki, göstəriş anlaşılmazdır.`,
    },
    correct: 'A',
    explanation: `Rəhbərlə ünsiyyət erkən, şəffaf və həll yönümlü olmalıdır. A variantı dəqiqləşdirməni vaxtında və konstruktiv aparır, itki riskini azaldır. B variantı yanlış təxminlə baha səhvə yol aça bilər. C variantı passiv gecikmədir. D variantı problemi həll etmir, yalnız narazılığı yayır.`,
  },
  {
    id: 'smt-l6-q4', course: 'smt', lesson_number: 6, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Həmkarınız sizinlə bir problem barədə danışır və narahatdır. Ən effektiv reaksiya hansıdır?`,
    options: {
      A: `Dərhal həll təklif edib söhbəti bitirin.`,
      B: `Diqqətlə dinləyin, anladığınızı təsdiqləyin və yalnız sonra birlikdə həll axtarın.`,
      C: `Öz oxşar təcrübənizi danışmağa başlayın.`,
      D: `"Bu o qədər də ciddi deyil" deyib sakitləşdirməyə çalışın.`,
    },
    correct: 'B',
    explanation: `Aktiv dinləmə prinsipi. B variantı əvvəlcə anlamağa yönəlir, sonra həll axtarır. A variantı tələsik həll problemin əsl mahiyyətini gözdən qaçıra bilər. C variantı diqqəti öz üzərinizə çəkir. D variantı qarşı tərəfin hissini dəyərsizləşdirir, etibarı azaldır.`,
  },
  {
    id: 'smt-l6-q5', course: 'smt', lesson_number: 6, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Həmkarınızın səhvi sizin işinizə təsir edib. Məsələni müzakirə etmək istəyirsiniz. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Səhvi ümumi yığıncaqda hamının yanında dilə gətirin.`,
      B: `Heç nə deməyib özünüz düzəldin və narahatlığı içinizdə saxlayın.`,
      C: `Təkbətək, faktla başlayaraq birlikdə həll yolu axtarın.`,
      D: `Rəhbərə şikayət edin, həmkarınızla isə danışmayın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Konkret, davranış əsaslı və münasibəti qoruyan ünsiyyət prinsipi. C variantı ən effektivdir: təkbətək, faktla, həll yönümlü. A variantı ən az effektivdir: ictimai tənqid utandırır və müdafiə yaradır. B variantı problemi həll etmir, D isə birbaşa söhbəti ötürərək münasibəti zədələyir.`,
  },
  {
    id: 'smt-l6-q6', course: 'smt', lesson_number: 6, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Çətin rəy söhbətini aparırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Müşahidə etdiyiniz konkret faktı qeyd edin.`,
      B: `Birlikdə həll yolu və növbəti addımı razılaşdırın.`,
      C: `Qarşı tərəfin izahını dinləyin.`,
      D: `Söhbəti emosional ittihamla yekunlaşdırın.`,
    },
    correct: ['A', 'C', 'B', 'D'],
    explanation: `Effektiv rəy söhbətində: əvvəlcə A fakt, sonra C dinləmə, sonra B birgə həll yolu. D variantı ən az effektivdir, çünki emosional ittiham söhbətin konstruktivliyini pozur və münasibəti zədələyir.`,
  },
  {
    id: 'smt-l7-q1', course: 'smt', lesson_number: 7, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Pasport xidməti ofisində bir vətəndaş sənədinin gecikməsinə görə narazıdır və səsini qaldırır. Ən effektiv davranış hansıdır?`,
    options: {
      A: `"Növbənizi gözləyin" deyib söhbəti kəsin.`,
      B: `Onu sakitləşdirmək üçün mümkün olmayan vədlər verin.`,
      C: `Mübahisəyə girib özünüzü müdafiə edin.`,
      D: `Sakit dinləyin, narahatlığını qəbul edin, vəziyyəti aydınlaşdırın və konkret növbəti addımı izah edin.`,
    },
    correct: 'D',
    explanation: `Vətəndaş xidmətinin əsas elementləri dinləmək, empatiya göstərmək, aydınlıq yaratmaq və konkret həll təqdim etməkdir. D variantı bu dörd elementi birləşdirir. A variantı vətəndaşı rədd edir. B variantında yerinə yetirilməsi mümkün olmayan vəd etibarı pozur. C variantı münaqişəni böyüdür.`,
  },
  {
    id: 'smt-l7-q2', course: 'smt', lesson_number: 7, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `İki həmkarınız arasında gərginlik yaranıb. Siz onların həmkarısınız, rəhbəri deyilsiniz. Ən effektiv ilk addım hansıdır?`,
    options: {
      A: `Onları birbaşa, sakit şəkildə məsələni öz aralarında həll etməyə təşviq edin.`,
      B: `Dərhal rəhbərə xəbər verin ki, məsələ böyüməsin.`,
      C: `Daha çox simpatiya duyduğunuz tərəfi dəstəkləyin.`,
      D: `Məsələyə qarışmayın və hər ikisindən uzaq durun.`,
    },
    correct: 'A',
    explanation: `Münaqişənin həlli ardıcıllığı birbaşa danışıqdan başlayır, sonra vasitəçilik, ən sonda eskalasiya. A variantı ən aşağı və ən konstruktiv səviyyədən başlayır. B variantı vaxtından əvvəl eskalasiyadır. C variantı tərəf tutma tələsidir. D variantı problemi tamamilə görməzdən gəlir.`,
  },
  {
    id: 'smt-l7-q3', course: 'smt', lesson_number: 7, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bir layihədə müxtəlif maraqlı tərəflər (şöbələr) fərqli nəticələr istəyir. Ən effektiv idarəetmə hansıdır?`,
    options: {
      A: `Ən nüfuzlu şöbənin istəyini müzakirəsiz qəbul edin.`,
      B: `Şəffaflıq, tarazlıq və ədalətli proses əsasında tərəfləri eyni müzakirə masasında birləşdirin.`,
      C: `Hər kəsə ayrı-ayrılıqda fərqli söz verin ki, hamı razı qalsın.`,
      D: `Qərarı təxirə salıb gözləyin, bəlkə özləri razılaşar.`,
    },
    correct: 'B',
    explanation: `Maraqlı tərəflərin idarə edilməsi şəffaflıq, tarazlıq və proses üzərində qurulur. B variantı bu prinsipə uyğundur. A variantı güclü tərəfin mövqeyini əsas götürməkdir. C variantında ziddiyyətli vədlər etibarı zədələyir. D passiv gecikmədir, problemi həll etmir.`,
  },
  {
    id: 'smt-l7-q4', course: 'smt', lesson_number: 7, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `İcma idman mərkəzində bir üzv "cədvəli dəyişin" deyə tələb edir, lakin söhbətdən aydın olur ki, əsl narahatlığı izdihamdır. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Yalnız sözlə deyilən tələbi, yəni cədvəl dəyişikliyini icra edin.`,
      B: `Tələbi rədd edin, çünki cədvəl artıq təsdiqlənib.`,
      C: `Səthi tələbin altındakı əsl narahatlığı (izdiham) aydınlaşdırıb ona uyğun həll axtarın.`,
      D: `Üzvə "başqaları da uyğunlaşır" deyib məsələni bağlayın.`,
    },
    correct: 'C',
    explanation: `Burada əsas məsələ səsləndirilən tələbin arxasındakı əsl ehtiyacı görməkdir. C variantı əsl narahatlığı aşkarlayır və daha uyğun həll tapır. A variantı yalnız səthi tələbə fokuslanır. B və D narahatlığı tamamilə nəzərə almır.`,
  },
  {
    id: 'smt-l7-q5', course: 'smt', lesson_number: 7, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `İki komanda üzvü arasında vasitəçilik etməyiniz xahiş olunub. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Hansı tərəfin haqlı olduğunu şəxsi simpatiyanıza görə qərarlaşdırın.`,
      B: `Tərəflərdən birini digərinin yanında qınayın.`,
      C: `Hər iki tərəfi ayrıca dinləyin, ümumi müzakirə masasında şəxsə deyil, məsələyə fokuslanın.`,
      D: `Neytral mövqe tutub məsələni faktlar üzərində aparın.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Neytral, strukturlu vasitəçilik prinsipi. D variantı ən effektivdir: neytrallıq və faktlara əsaslanan yanaşma. A variantı ən az effektivdir: simpatiyaya görə qərar tərəf tutma tələsidir. C də yaxşı yanaşmadır, lakin D neytrallığı daha açıq vurğulayır. B variantı isə tərəflərdən birini qınayaraq münaqişəni dərinləşdirir.`,
  },
  {
    id: 'smt-l7-q6', course: 'smt', lesson_number: 7, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Komandanızın iki üzvü eyni işə kimin rəhbərlik edəcəyi üstündə davamlı gərginlik yaşayır. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Lazım gələrsə məsələni rəhbərə eskalasiya edin.`,
      B: `Tərəfləri neytral vasitəçiliklə bir masaya gətirin.`,
      C: `Tərəfləri birbaşa, sakit danışığa təşviq edin və gözləntiləri aydınlaşdırın.`,
      D: `Tərəflərdən birini dəstəkləyib qərarı onun xeyrinə verin.`,
    },
    correct: ['C', 'B', 'A', 'D'],
    explanation: `Münaqişənin həlli ardıcıllığı: əvvəlcə C birbaşa, sakit danışıq və gözləntilərin aydınlaşdırılması, sonra B neytral vasitəçilik, sonra A eskalasiya. D tərəf tutmaq ən az effektivdir, çünki münaqişəni həll etmir, əksinə dərinləşdirir.`,
  },
  {
    id: 'smt-l8-q1', course: 'smt', lesson_number: 8, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Çörək istehsalı sexində komanda rəhbərisiniz. Yeni üzv Lalə bir prosesdə çətinlik çəkir. Ən effektiv liderlik davranışı hansıdır?`,
    options: {
      A: `Çətinliyin səbəbini birlikdə anlayıb ona inkişaf üçün dəstək və təlim verin.`,
      B: `Tapşırığı dərhal başqa şəxsə həvalə edin.`,
      C: `Onu komanda yanında tənqid edin ki, daha diqqətli olsun.`,
      D: `Heç nə deməyin, özü öyrənənə qədər gözləyin.`,
    },
    correct: 'A',
    explanation: `Lider sadəcə tapşırıq vermir, inkişaf etdirir. A variantı səbəbi anlayır və məqsədli dəstək verir. B variantı inkişaf imkanını əlindən alır. C variantı ictimai tənqid psixoloji təhlükəsizliyi pozur. D variantı dəstəksiz buraxmaqdır, çətinliyi uzadır.`,
  },
  {
    id: 'smt-l8-q2', course: 'smt', lesson_number: 8, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Komandanızda iki üzv fərqli amillərlə motivasiya olunur: biri yeni bacarıq öyrənməyi, digəri açıq şəkildə tanınmağı sevir. Ən effektiv liderlik yanaşması hansıdır?`,
    options: {
      A: `Hər ikisinə eyni cür, eyni mükafatla yanaşın.`,
      B: `Hər birinin fərdi motivasiyasını anlayıb yanaşmanı ona uyğunlaşdırın.`,
      C: `Yalnız öz motivasiyanıza uyğun üsulu tətbiq edin.`,
      D: `Motivasiya şəxsi məsələdir deyə nəzərə almayın.`,
    },
    correct: 'B',
    explanation: `Motivasiyanı fərdi səviyyədə anlamaq prinsipi. B variantı hər kəsin fərqli motivasiya mənbələrini tanıyıb yanaşmasını buna uyğunlaşdırır. A variantı "hamıya eyni" yanaşması fərdi fərqləri görməzdən gəlir. C variantı öz motivasiyası əsasında ümumiləşdirmə aparır. D variantı motivasiyanı liderlik məsuliyyətindən kənar sayır.`,
  },
  {
    id: 'smt-l8-q3', course: 'smt', lesson_number: 8, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bir komanda üzvünün performansı son həftələrdə zəifləyir. Ən effektiv liderlik müdaxiləsi hansıdır?`,
    options: {
      A: `Problemin böyüməsini gözləyin, bəlkə öz-özünə düzələr.`,
      B: `Performans qiymətləndirməsinə qədər heç nə deməyin.`,
      C: `Erkən, birbaşa, lakin mehriban şəkildə konkret nümunələrlə söhbət edin və dəstək təklif edin.`,
      D: `Üzvü digərləri yanında nümunə kimi tənqid edin.`,
    },
    correct: 'C',
    explanation: `Zəif performansa müdaxilə erkən, birbaşa və mehriban olmalıdır. C variantı bu prinsipə uyğundur, konkret və dəstəkləyicidir. A və B gecikmədir, problem daha da dərinləşə bilər. D variantı ictimai tənqid psixoloji təhlükəsizliyi və münasibəti pozur.`,
  },
  {
    id: 'smt-l8-q4', course: 'smt', lesson_number: 8, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Komanda üzvü etdiyi səhvi bildirməkdən çəkinir. Lider kimi ən effektiv davranış hansıdır?`,
    options: {
      A: `Səhv edən hər kəsi sərt cəzalandırın ki, diqqətli olsunlar.`,
      B: `Səhvləri yalnız özünüz aşkar edib düzəldin.`,
      C: `Səhv haqqında danışmağı qadağan edin ki, mənfilik yayılmasın.`,
      D: `Səhvlərin açıq danışıldığı və öyrənmə fürsətinə çevrildiyi mühit yaradın.`,
    },
    correct: 'D',
    explanation: `Psixoloji təhlükəsizlik prinsipi (Amy Edmondson): insanlar cəzadan qorxmadan problemi açıq şəkildə bildirməlidir. D variantı belə bir mühit yaradır. A variantı qorxu mühiti yaradır, səhvlərin gizlədilməsinə səbəb olur. B variantı problemi gec aşkar edir. C variantı açıqlığı tamamilə məhdudlaşdırır.`,
  },
  {
    id: 'smt-l8-q5', course: 'smt', lesson_number: 8, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Komanda üzvü yaxşı iş görüb. Əməyin tanınması ilə bağlı ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Əməyin tanınmasını "uyğun an gələndə" deyə qeyri-müəyyən gələcəyə saxlayın.`,
      B: `Konkret nəyi yaxşı etdiyini vaxtında və səmimi qeyd edin.`,
      C: `Ümumi "afərin" deyib keçin.`,
      D: `Heç nə deməyin, çünki bu, onun vəzifəsidir.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Əməyin tanınması vaxtında və konkret olmalıdır. B ən effektivdir. A variantı ən az effektivdir: əməyin tanınmasını təxirə salmaq motivasiyanı azaldır və tipik liderlik tələsidir. C səthi əməyin tanınmasıdır, D variantı isə əməyin tanınmasından tamamilə imtina etməkdir.`,
  },
  {
    id: 'smt-l8-q6', course: 'smt', lesson_number: 8, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Bacarıqlı, lakin son vaxtlar zəif performans göstərən üzvə yanaşırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Onu başqaları yanında tənqid edin.`,
      B: `Birlikdə dəstək və inkişaf planı qurun.`,
      C: `Razılaşdırılmış nöqtələrlə irəliləyişi izləyin.`,
      D: `Erkən, təkbətək, konkret nümunələrlə söhbət edin.`,
    },
    correct: ['D', 'B', 'C', 'A'],
    explanation: `Effektiv liderlik müdaxiləsi: əvvəlcə D erkən və təkbətək söhbət, sonra B dəstək planı, sonra C izləmə. A ən az effektivdir, çünki ictimai tənqid psixoloji təhlükəsizliyi pozur və performansı daha da zəiflədə bilər.`,
  },
  {
    id: 'smt-l9-q1', course: 'smt', lesson_number: 9, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Vergi ofisində yeni rəqəmsal sistem tətbiq olunur və bəzi əməkdaşlar buna müqavimət göstərir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Müqaviməti maneə sayıb göstərişlə susdurun.`,
      B: `Müqaviməti məlumat kimi qəbul edin və narahatlıqların səbəbini anlayın.`,
      C: `Narazıları nəzərə almayın, zamanla öyrəşərlər.`,
      D: `Sistemi geri çəkib köhnə üsulda qalın.`,
    },
    correct: 'B',
    explanation: `Müqavimətin maneə deyil, məlumat olması prinsipi. B variantı müqavimətin arxasındakı real narahatlığı (bacarıq, iş yükü, qorxu) anlayır. A variantında müqaviməti güclə susdurmaq onu gizlədir. C variantı narahatlığı görməzdən gəlir. D variantı dəyişiklikdən tamamilə imtinadır.`,
  },
  {
    id: 'smt-l9-q2', course: 'smt', lesson_number: 9, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Komandanıza yeni iş prosesini izah edirsiniz. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `"Belə qərar verilib" deyib detallara girməyin.`,
      B: `Yalnız müsbət tərəfləri deyib çətinlikləri gizlədin.`,
      C: `Dəyişikliyin zərurətini faktlarla izah edin və komandanın narahatlıqlarına empatiya göstərin.`,
      D: `Dəyişikliyi e-poçtla bildirib müzakirə açmayın.`,
    },
    correct: 'C',
    explanation: `Dəyişikliyin zərurəti faktlar və empatiya ilə izah olunmalıdır. C variantı hər ikisini birləşdirir. A variantı sadəcə əmr xarakteri daşıyır, anlayış yaratmır. B şəffaf deyil, etibarı zədələyir. D variantı birtərəfli bildirişdir, dialoq və dəstəyə imkan vermir.`,
  },
  {
    id: 'smt-l9-q3', course: 'smt', lesson_number: 9, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Dəyişiklik zamanı komandanın bəzi üzvləri digərlərindən daha çox çətinlik çəkir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Hamıya eyni ümumi təlimat verib fərqləri nəzərə almayın.`,
      B: `Çətinlik çəkənləri geridə qoyub irəli gedənlərlə davam edin.`,
      C: `Çətinliyi əsas gətirib dəyişikliyi dayandırın.`,
      D: `Kimin daha çox dəstəyə ehtiyacı olduğunu müəyyən edib məqsədli dəstək göstərin.`,
    },
    correct: 'D',
    explanation: `Dəyişiklikdə hər kəsin ehtiyacı eyni deyil. D variantı dəstəyi ehtiyaca uyğun hədəfləyir. A variantı fərdi fərqləri görməzdən gəlir. B variantı insanları geridə qoyur, müqaviməti artırır. C variantı bir çətinlik üzündən bütün dəyişikliyi dayandırır.`,
  },
  {
    id: 'smt-l9-q4', course: 'smt', lesson_number: 9, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Yeni iş üsulu təqdim edirsiniz, lakin komanda nəticələrdən qorxur. Qorxunu azaltmaq üçün ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Yeni üsulu sınaq dövrü kimi təqdim edin, rəy toplayıb sonra qərar verəcəyinizi bildirin.`,
      B: `"Bu, son qərardır, geri yol yoxdur" deyin.`,
      C: `Köhnə üsulu dərhal tamamilə ləğv edin.`,
      D: `Dəyişikliyi heç izah etmədən tətbiq edin.`,
    },
    correct: 'A',
    explanation: `Sınaq dövrü kimi təqdim etmək qorxunu azaldır, çünki qərarın dəyişdirilə bilməyəcəyi hissini aradan qaldırır. A variantı bu prinsipə uyğundur. B variantı qərarın dəyişdirilə bilməyəcəyi qorxusunu artırır. C variantı köhnəni dərhal ləğv etmək tipik tələdir, keçid üçün dayaq nöqtəsini aradan qaldırır. D variantı izahsız tətbiq müqaviməti gücləndirir.`,
  },
  {
    id: 'smt-l9-q5', course: 'smt', lesson_number: 9, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Yeni prosesi tətbiq edirsiniz. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Dəyişikliyi izah etmədən bir gündə tətbiq edin.`,
      B: `Köhnə sistemi yalnız formal olaraq saxlayıb praktikada işlətməyin.`,
      C: `Mərhələli tətbiq edin, hər mərhələdə rəy toplayıb düzəliş aparın.`,
      D: `Köhnə sistemi bir gecədə tamamilə ləğv edin.`,
    },
    correct: { best: 'C', worst: 'D' },
    explanation: `Dəyişikliyin idarə edilməsində mərhələli tətbiq və sınaq prinsipi. C variantı ən effektivdir: addım-addım, rəylə düzəliş. D variantı ən az effektivdir: köhnə sistemi bir gecədə ləğv etmək keçid üçün dayaq nöqtəsini aradan qaldırır və riski artırır. A variantı izahsız tətbiqdir, B variantı isə yarımçıq və ziddiyyətli vəziyyət yaradır.`,
  },
  {
    id: 'smt-l9-q6', course: 'smt', lesson_number: 9, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Dəyişiklik təşəbbüsünü idarə edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Köhnə üsulu izahsız, dərhal ləğv edin.`,
      B: `Müqaviməti dinləyib fərdi dəstək verin.`,
      C: `Sınaq dövrü kimi mərhələli tətbiq edib rəy toplayın.`,
      D: `Dəyişikliyin zərurətini faktlar və empatiya ilə izah edin.`,
    },
    correct: ['D', 'B', 'C', 'A'],
    explanation: `Effektiv dəyişiklik ardıcıllığında: əvvəlcə D (zərurətin izahı), sonra B (müqaviməti dinləmək və dəstək vermək), sonra C (mərhələli sınaq). A ən az effektivdir, çünki köhnə üsulu izahsız və dərhal ləğv etmək qorxunu və müqaviməti maksimuma çatdırır.`,
  },
  {
    id: 'smt-l10-q1', course: 'smt', lesson_number: 10, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Təkrar emal müəssisəsində çeşidləmə xətti tez-tez tıxanır. Komanda üzvü Rəşad "daha çox işçi lazımdır" deyir. Ən effektiv innovativ yanaşma hansıdır?`,
    options: {
      A: `Problemə yeni baxış bucağından baxıb tıxanmanın kök səbəbini və prosesin quruluşunu yenidən nəzərdən keçirin.`,
      B: `Dərhal əlavə işçi götürün ki, xətt sürətlənsin.`,
      C: `Tıxanmanı işin təbii hissəsi hesab edib davam edin.`,
      D: `Xətti söndürüb problemi sonraya saxlayın.`,
    },
    correct: 'A',
    explanation: `İnnovasiya problemi yeni baxış bucağı ilə görməkdən başlayır. A səbəbi və prosesin özünü yenidən qiymətləndirir, əlamətə deyil, prosesin quruluşuna baxır. B yalnız resurs əlavə edir, kök səbəbi həll etmir. C problemi normal qəbul edərək hərəkətsiz qalır. D variantı passiv təxirə salmadır.`,
  },
  {
    id: 'smt-l10-q2', course: 'smt', lesson_number: 10, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Arıçılıq kooperativində məhsuldarlıq aşağıdır və bir nəfər ağlına gələn ilk həlli təklif edir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `İlk təklifi dərhal tətbiq edin, vaxt itirməyin.`,
      B: `Bir neçə fərqli həll variantı yaradıb onları müqayisə edin.`,
      C: `Heç nəyi dəyişməyin, vəziyyət öz-özünə düzələ bilər.`,
      D: `Yalnız başqa kooperativlərin etdiyini eynilə təkrarlayın.`,
    },
    correct: 'B',
    explanation: `İnnovasiyada çoxlu alternativ yaratmaq prinsipi. B müxtəlif variantları qiymətləndirib daha yaxşı seçim imkanı verir. A tək varianta bağlanır. C passivdir. D mexaniki təkrarlamadır, kontekstə uyğunluğu yoxlamır.`,
  },
  {
    id: 'smt-l10-q3', course: 'smt', lesson_number: 10, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Günəş panelləri quraşdıran şirkət yeni, daha sürətli montaj üsulu sınamaq istəyir, lakin nəticəsi qeyri-müəyyəndir. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Yeni üsulu dərhal bütün briqadalarda tətbiq edin.`,
      B: `Yeni üsuldan tamamilə imtina edin, çünki risklidir.`,
      C: `Kiçik pilot layihədə sınayıb nəticələrə əsasən tədricən genişləndirin.`,
      D: `Üsulu heç sınamadan rəhbərliyə təsdiq üçün təqdim edin.`,
    },
    correct: 'C',
    explanation: `Düzgün yanaşma hesablanmış riskdir: əvvəlcə pilot sınaq, sonra nəticənin ölçülməsi və genişləndirilmə. C variantı riski məhdud sınaqla idarə edir. A sınaqsız tam miqyasda tətbiq etmək böyük risk daşıyır. B variantı isə innovasiyadan tamamilə imtinadır. D fakt olmadan təqdimatdır, qərarı əsaslandırmır.`,
  },
  {
    id: 'smt-l10-q4', course: 'smt', lesson_number: 10, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `İcma bağı layihəsində yeni bir ideyanı rəhbərinizə təqdim etmək istəyirsiniz. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `İdeyanı emosional təkidlə müdafiə edin ki, rəhbər razılaşsın.`,
      B: `İdeyanı ümumiyyətlə təqdim etməyin, rədd edilə bilər.`,
      C: `Rəhbər özü soruşana qədər gözləyin.`,
      D: `İdeyanı potensial fayda, mümkün risk və kiçik sınaq planı ilə faktlara əsaslanaraq təqdim edin.`,
    },
    correct: 'D',
    explanation: `İnnovasiyanı həyata keçirmək üçün rəhbəri faktlarla inandırmaq lazımdır. D variantı faydanı, riski və sınaq planını birləşdirir. A variantı emosional təkid etibarlılığı azaldır. B və C variantları təşəbbüsdən imtinadır, ideya heç vaxt qiymətləndirilmir.`,
  },
  {
    id: 'smt-l10-q5', course: 'smt', lesson_number: 10, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Yeni bir xidmət ideyanız var, lakin nəticəsi tam aydın deyil. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `İdeyanı bir neçə mövcud alternativlə müqayisə edin.`,
      B: `İdeyanı heç sınamadan "alınmaz" deyib rədd edin.`,
      C: `İdeyanı dərhal tam miqyasda işə salın.`,
      D: `Hesablanmış risklə kiçik pilot qurub nəticəyə görə qərar verin.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Yeni həll əvvəlcə kiçik miqyasda sınanmalıdır. D variantı məhdud pilot sınaq vasitəsilə nəticə çıxarmağa imkan yaratdığı üçün ən effektivdir. B variantı ideyanı sınamadan rədd etdiyi üçün innovasiyanı tamamilə dayandırır, ən az effektivdir. C variantı sınaqsız tam miqyaslı tətbiqi nəzərdə tutduğu üçün böyük risk daşıyır. A variantı faydalı müqayisədir, lakin təkbaşına nəticə vermir.`,
  },
  {
    id: 'smt-l10-q6', course: 'smt', lesson_number: 10, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Yeni həll fikrini reallaşdırırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Ağlınıza gələn ilk ideyanı dərhal tam tətbiq edin.`,
      B: `Rəhbəri fayda və risk üzrə faktlarla inandırın.`,
      C: `Problemi yeni baxış bucağından təhlil edin.`,
      D: `Bir neçə alternativ yaradıb pilot sınaq aparın.`,
    },
    correct: ['C', 'D', 'B', 'A'],
    explanation: `İnnovasiya prosesi: əvvəlcə C problemi yenidən çərçivələndirmək, sonra D alternativlər və pilot sınaq, sonra B faktlarla inandırma. A ən az effektivdir, çünki sınaqsız şəkildə tək ideyanı dərhal tam tətbiq etmək ən yüksək riskdir.`,
  },
  {
    id: 'smt-l11-q1', course: 'smt', lesson_number: 11, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Sertifikatlaşdırma qurumunda işləyirsiniz. Bir tanışınız qaydadan kiçik güzəşt istəyir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Xahişi yerinə yetirin, axı bu, kiçik məsələdir.`,
      B: `Bu qərarın açıq elan olunsa özünüzü rahat hiss edib-etməyəcəyinizi, yəni şəffaflıq testini tətbiq edin.`,
      C: `Xahişi gizli, sənədsiz yerinə yetirin.`,
      D: `Tanışınızı kobud şəkildə rədd edib əlaqəni kəsin.`,
    },
    correct: 'B',
    explanation: `Etik qərarda şəffaflıq testi əsas vasitədir: bu qərar ictimailəşsə, rahat olarammı? B məhz bunu tətbiq edir. A güzəşti əsaslandırmadan verir. C gizlilik şəffaflığı pozur. D variantı etik məsələni kobudluqla qarışdırır, münasibətə lazımsız zərər verir.`,
  },
  {
    id: 'smt-l11-q2', course: 'smt', lesson_number: 11, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Qrant qiymətləndirmə komitəsinin üzvüsünüz. Qiymətləndirməli olduğunuz layihələrdən biri yaxın tanışınıza aiddir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Heç nə deməyin, çünki obyektiv qalacağınıza əminsiniz.`,
      B: `Tanışınızın layihəsinə üstünlük verin.`,
      C: `Maraqlar toqquşması ehtimalını açıqlayıb həmin qiymətləndirmədən kənarlaşın.`,
      D: `Etiraz əlaməti olaraq bütün layihələri rədd edin.`,
    },
    correct: 'C',
    explanation: `Maraqlar toqquşmasının görünüşü də fakt kimi qəbul edilməlidir. C variantı toqquşmanı açıqlayır və qiymətləndirmədən kənarlaşır, prosesə etibarı qoruyur. A variantındakı "mən obyektivəm" yanaşması görünüş riskini görməzdən gəlir. B variantı birbaşa maraqlar toqquşmasıdır. D variantı isə qeyri-mütənasib, ədalətsiz reaksiyadır.`,
  },
  {
    id: 'smt-l11-q3', course: 'smt', lesson_number: 11, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Xeyriyyə fondunda başqa bir şöbənin hesabatında ciddi bir xəta görürsünüz. Bu, birbaşa sizin işiniz deyil. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Sizin işiniz olmadığı üçün məhəl qoymayın.`,
      B: `Xətanı görməzdən gəlib gizlədin.`,
      C: `Xətanı sosial şəbəkədə ictimai şəkildə paylaşın.`,
      D: `Xətanı aidiyyəti şəxsə peşəkar və konstruktiv şəkildə bildirin.`,
    },
    correct: 'D',
    explanation: `Ciddi xətanı gördükdə düzgün kanal vasitəsilə bildirmək peşəkar borcdur. D bunu peşəkar şəkildə edir. A və B variantları məsuliyyətdən qaçır. C variantı isə daxili məsələni ictimailəşdirərək həm etik, həm peşəkar baxımdan yanlışdır.`,
  },
  {
    id: 'smt-l11-q4', course: 'smt', lesson_number: 11, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `İşdə sizə əsassız bir ittiham yönəlib. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Faktlara və sənədlərə əsaslanan sakit izah verin.`,
      B: `Emosional şəkildə qarşı tərəfi ittiham edin.`,
      C: `Heç nə deməyib məsələni olduğu kimi buraxın.`,
      D: `Məsələni şişirdib böyük münaqişəyə çevirin.`,
    },
    correct: 'A',
    explanation: `Özünü müdafiə emosional deyil, faktlara əsaslanan olmalıdır. A variantı sənədlərə və faktlara əsaslanaraq sakit izah verir. B variantı emosional əks-ittiham vəziyyəti gərginləşdirir. C variantı özünü müdafiə etməməkdir, yanlış təəssürat yarana bilər. D variantı həddindən artıq reaksiyadır, problemi böyüdür.`,
  },
  {
    id: 'smt-l11-q5', course: 'smt', lesson_number: 11, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `İşdə verdiyiniz bir qərar sorğulanır. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Qərarın səbəbini sənədlərə və faktlara əsaslanaraq sakit şəkildə izah edin.`,
      B: `Məsələni tamamilə görməzdən gəlin.`,
      C: `Qərarı qismən, ümumi sözlərlə izah edin.`,
      D: `Həddindən artıq müdafiəyə keçib hər kəsi günahlandırın.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Faktlara əsaslanan, ölçülü özünü müdafiə prinsipi. A variantı ən effektivdir: sənəd və faktlara əsaslanaraq sakit izah. D variantı ən az effektivdir: həddindən artıq müdafiə və hamını günahlandırmaq tipik etik tələlərdən biridir, etibarı zədələyir. B variantı məsələni açıq qoyur, C variantı isə kifayət qədər aydın deyil.`,
  },
  {
    id: 'smt-l11-q6', course: 'smt', lesson_number: 11, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `İşdə etik baxımdan həssas ittiham və ya sorğu ilə üzləşmisiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Məsələni emosional münaqişəyə çevirin.`,
      B: `Lazım gələrsə aidiyyəti şəxsə və ya quruma məlumat verin.`,
      C: `Faktları və sənədləri toplayın.`,
      D: `Sakit qalıb vəziyyəti obyektiv qiymətləndirin.`,
    },
    correct: ['D', 'C', 'B', 'A'],
    explanation: `Etik məsələdə düzgün ardıcıllıq: əvvəlcə D (sakit qiymətləndirmə), sonra C (faktların və sənədlərin toplanması), sonra B (lazım olduqda məlumatlandırma). A ən az effektivdir, çünki emosional münaqişə həm həll prosesinə, həm də peşəkar nüfuza zərər verir.`,
  },
  {
    id: 'smt-l12-q1', course: 'smt', lesson_number: 12, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Yeni filialın açılışına məsulsunuz. Güclü tərəfiniz analitik təhlildir, lakin vəziyyət həm də komanda ilə sıx ünsiyyət tələb edir. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Yalnız ən güclü bacarığınıza, yəni təhlilə güvənin.`,
      B: `Bacarıqları ümumiyyətlə nəzərə almadan irəliləyin.`,
      C: `Vəziyyətin tələbinə uyğun olaraq təhlil, ünsiyyət və liderliyi birləşdirin.`,
      D: `Bütün qərarları başqasına ötürün.`,
    },
    correct: 'C',
    explanation: `İnteqrasiya vəziyyətin tələbinə uyğun olaraq müxtəlif bacarıqları birləşdirməkdir. C variantı bunu edir. A variantı aparıcı bacarığa həddindən artıq güvənmə tələsidir, vəziyyətin digər tələblərini qaçırır. B variantı bacarıqları görməzdən gəlir. D variantı məsuliyyətdən imtinadır.`,
  },
  {
    id: 'smt-l12-q2', course: 'smt', lesson_number: 12, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Regional layihə eyni anda dəqiq təhlil, aydın ünsiyyət və yaxşı planlaşdırma tələb edir. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Hər problemi eyni üsulla həll edin.`,
      B: `Yalnız bir şöbənin baxışına əsaslanın.`,
      C: `Qərarları ardıcıllıq olmadan, təsadüfi verin.`,
      D: `Analitik təhlili, ünsiyyətnı və planlaşdırmanı vəziyyətə uyğun birləşdirin.`,
    },
    correct: 'D',
    explanation: `İnteqrasiya prinsipi bacarıqları vəziyyətə uyğun birləşdirməkdir. D variantı bunu edir. A variantı tək üsul bütün problemlərə uyğun gəlmir. B variantı tək baxış bucağı məhduddur. C variantı sistemsiz yanaşmadır, nəticəni təsadüfə buraxır.`,
  },
  {
    id: 'smt-l12-q3', course: 'smt', lesson_number: 12, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bir münaqişə həm faktların təhlilini, həm də tərəflərin münasibətlərinin nəzərə alınmasını tələb edir. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Həm faktları təhlil edin, həm tərəflərin münasibətini və emosiyalarını nəzərə alın.`,
      B: `Yalnız faktlara baxın və münasibətləri tamamilə nəzərdən qaçırın.`,
      C: `Yalnız münasibətlərə baxın və faktları nəzərdən qaçırın.`,
      D: `Qərardan ümumiyyətlə qaçın.`,
    },
    correct: 'A',
    explanation: `İnteqrasiya analitik düşüncə ilə sosial mühakiməni birləşdirir. A variantı hər iki ölçünü nəzərə alır. B variantı yalnız faktlara fokuslanmaqla münasibətləri zədələyə bilər. C variantı yalnız münasibətlərə fokuslanmaqla düzgün qərarı itirə bilər. D variantı qərardan qaçmaq problemi həll etmir.`,
  },
  {
    id: 'smt-l12-q4', course: 'smt', lesson_number: 12, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Yeni xidmət xətti açılır: bu, planlaşdırma, dəyişikliyin idarə edilməsi və komanda ilə ünsiyyət tələb edir. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Yalnız planı düşünərək komandanı nəzərdən qaçırın.`,
      B: `Planlaşdırma, dəyişikliyin idarə edilməsi və ünsiyyətnı birlikdə tətbiq edin.`,
      C: `Yalnız komandanı düşünüb planı kənara qoyun.`,
      D: `Heç bir addım atmayın, vəziyyət aydınlaşana qədər gözləyin.`,
    },
    correct: 'B',
    explanation: `İnteqrasiya çoxşaxəli tapşırıq zamanı uyğun bacarıqların birlikdə tətbiq edilməsidir. B variantı üç bacarığı birləşdirir. A və C variantları yalnız birinə fokuslanaraq digər aspektləri zəiflədir. D variantı passiv gözləmədir, imkanı itirə bilər.`,
  },
  {
    id: 'smt-l12-q5', course: 'smt', lesson_number: 12, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Qarşınızda eyni anda bir neçə bacarıq tələb edən çoxşaxəli problem var. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Bir neçə bacarığı qismən, səthi tətbiq edin.`,
      B: `Vəziyyətin tələbinə uyğun olaraq uyğun bacarıqları balanslı şəkildə birləşdirin.`,
      C: `Yalnız ən güclü bacarığınıza güvənib qalanını nəzərə almayın.`,
      D: `Problemi hissələrə bölüb hər hissəni ayrıca başqasına ötürün.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `İnteqrasiya prinsipi burada əsasdır. B ən effektivdir: bacarıqları vəziyyətə görə balanslı birləşdirir. C variantı ən az effektivdir: aparıcı bacarığa həddindən artıq güvənmək vəziyyətin digər tələblərini qaçıran tipik tələdir. A səthi tətbiqdir, D isə məsuliyyəti tam parçalayır.`,
  },
  {
    id: 'smt-l12-q6', course: 'smt', lesson_number: 12, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Çoxşaxəli bir vəziyyətdə bacarıqlarınızı birlikdə tətbiq edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Vəziyyətin hansı bacarıqları tələb etdiyini müəyyən edin.`,
      B: `Yalnız bir bacarığa güvənib davam edin.`,
      C: `Uyğun bacarıqları birləşdirib həll qurun.`,
      D: `Nəticəni qiymətləndirib lazım gələrsə düzəliş edin.`,
    },
    correct: ['A', 'C', 'D', 'B'],
    explanation: `İnteqrasiya ardıcıllığı belədir: əvvəlcə A (tələb olunan bacarıqları müəyyən etmək), sonra C (onları birləşdirmək), sonra D (nəticəni qiymətləndirmək). B ən az effektivdir, çünki tək bir bacarığa güvənmək çoxşaxəli vəziyyətin tələblərini qarşılamır.`,
  },
  {
    id: 'ez-l1-q1', course: 'ez', lesson_number: 1, topic: 'ez',
    q_type: 'single', is_free: true, points: 1,
    question_az: `Görüşdə bir komanda üzvünün səs tonunda gərginlik hiss edirsiniz, baxmayaraq ki, sözləri sakitdir. Əsas prinsipə (emosiyalar məlumatdır) uyğun ən effektiv davranış hansıdır?`,
    options: {
      A: `Gərginliyi görməzdən gəlin, çünki sözlər sakitdir.`,
      B: `Görüşü dərhal dayandırın və problemin dərhal açıqlanmasını tələb edin.`,
      C: `Bu siqnalı məlumat kimi qəbul edin, bunun arxasında nəyin dayandığını anlamağa çalışın və lazım gələrsə nəzakətlə soruşun.`,
      D: `Bu hissin əhəmiyyətsiz olduğunu düşünün, çünki açıq deyilmiş heç nə yoxdur.`,
    },
    correct: 'C',
    explanation: `Əsas prinsip emosiyaları küy deyil, məlumat kimi qəbul etməyi tələb edir: oxu, anla, istifadə et, susdurma. C siqnalı oxuyur və anlamağa çalışır. A və D emosional siqnalı susdurur, yəni məlumatı itirir. B həddən artıq reaksiyadır, gərginliyi azaltmaq əvəzinə artırır.`,
  },
  {
    id: 'ez-l1-q2', course: 'ez', lesson_number: 1, topic: 'ez',
    q_type: 'single', is_free: true, points: 1,
    question_az: `Bir həmkarınız öz güclü emosiyasını peşəkar mühitdə susduraraq tamamilə gizlədir. Tənzimləmə ilə gizlətmə arasındakı fərqi nəzərə alaraq, sağlam yanaşma hansıdır?`,
    options: {
      A: `Emosiyanı tanıyaraq konstruktiv istiqamətə yönəltmək, yəni tənzimləmək.`,
      B: `Emosiyanı tamamilə susdurmaq, çünki peşəkar mühitdə hisslərə yer yoxdur.`,
      C: `Emosiyanı olduğu kimi, idarəsiz şəkildə ifadə etmək.`,
      D: `Emosiyanın səbəbini araşdırmamaq, çünki bu vacib deyil.`,
    },
    correct: 'A',
    explanation: `Tənzimləmə məlumatı qoruyaraq onu yönləndirir. Gizlətmə isə məlumatı aradan qaldırır. A variantı tənzimləmədir və doğru yanaşmadır. B gizlətmədir, məlumatı itirir. C idarəsiz ifadədir, tənzimləmə deyil. D variantı emosiyanı anlamaq bacarığını inkar edir.`,
  },
  {
    id: 'ez-l1-q3', course: 'ez', lesson_number: 1, topic: 'ez',
    q_type: 'single', is_free: true, points: 1,
    question_az: `Bir lider empatiyanı zəiflik əlaməti sayır və komanda üzvlərinin vəziyyətini başa düşməyə vaxt ayırmır. Bu baxış niyə yanlışdır?`,
    options: {
      A: `Empatiya qərarvermə qabiliyyətini zəiflədir.`,
      B: `Empatiya yalnız şəxsi münasibətlərdə işləyir, peşəkar mühitdə yox.`,
      C: `Empatiya zəiflik deyil, məlumat toplamaq vasitəsidir. Daha yaxşı qərar, kommunikasiya və komanda mühiti yaradır.`,
      D: `Empatiya yalnız çox hiss edən insanlar üçündür.`,
    },
    correct: 'C',
    explanation: `Empatiya, yəni başqasının vəziyyətini başa düşmək, zəiflik deyil, məlumat toplamaq vasitəsidir. C bunu düzgün izah edir. A, B və D empatiyanı yanlış olaraq məhdudlaşdırır və ya zərərli sayır. Əslində empatiya liderin qərar və ünsiyyət keyfiyyətini artırır.`,
  },
  {
    id: 'ez-l1-q4', course: 'ez', lesson_number: 1, topic: 'ez',
    q_type: 'dual', is_free: true, points: 1,
    question_az: `Komanda üzvü açıq narahatlıq bildirmir, lakin bədən dili və səs tonu gərginlik göstərir. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Gərginliyi müşahidə edin, lakin sonraya saxlayın.`,
      B: `Heç bir siqnal görmədiyinizi düşünün, çünki sözlər sakitdir.`,
      C: `Şəxsin gərginliyini hamının qarşısında dilə gətirin.`,
      D: `Siqnalı məlumat kimi qəbul edin, uyğun anda nəzakətlə vəziyyətini soruşun.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `D emosional siqnalı oxuyur və uyğun şəkildə istifadə edir (ən effektiv). B siqnalı tamamilə susdurur, yəni məlumatı itirir (ən az effektiv). C məlumatı düzgün oxuyur, lakin ictimai şəkildə, bu, münasibətə zərər verə bilər. A isə gecikdirir. Hər iki yanaşma qismən doğrudur, B isə prinsipi tamamilə pozur.`,
  },
  {
    id: 'ez-l1-q5', course: 'ez', lesson_number: 1, topic: 'ez',
    q_type: 'ranking', is_free: true, points: 1,
    question_az: `Bir görüşdə açıq şəkildə deyilməyən, lakin hiss olunan bir narahatlıq var. Aşağıdakı davranışları əsas prinsipə uyğunluğuna görə ən effektivdən ən az effektivə doğru sıralayın.`,
    options: {
      A: `Narahatlığı qeyd edin, lakin görüşdən sonraya saxlayın.`,
      B: `Narahatlığı tamamilə görməzdən gəlin və mövzuya davam edin.`,
      C: `Narahatlığı kobud şəkildə gündəmə gətirin və bunun kimin günahı olduğunu soruşun.`,
      D: `Narahatlığı hiss etdiyinizi sakit şəkildə dilə gətirin və birlikdə müzakirə etməyi təklif edin.`,
    },
    correct: ['D', 'A', 'B', 'C'],
    explanation: `D siqnalı oxuyur, anlayır və konstruktiv istifadə edir (ən effektiv). A siqnalı tanıyır, lakin gecikdirir. B siqnalı susdurur, məlumatı itirir. C siqnalı oxuyur, lakin idarəsiz və ittihamedici formada, münasibəti və mühiti zədələyir (ən az effektiv).`,
  },
  {
    id: 'ez-l1-q6', course: 'ez', lesson_number: 1, topic: 'ez',
    q_type: 'likert', is_free: true, points: 1,
    question_az: `Bir həmkarınız gərgin görünür. Aşağıdakı davranışların hər birini emosional zəka prinsipinə uyğunluğuna görə 1 (ən az uyğun) ilə 4 (ən uyğun) arasında qiymətləndirin.`,
    options: {
      A: `Gərginliyi tanıyın, mümkün səbəbini anlamağa çalışın və uyğun məqamda dəstək təklif edin.`,
      B: `Gərginliyi müşahidə edin, lakin müdaxilə etmədən izləyin.`,
      C: `Gərginliyi görməzdən gəlin və davam edin.`,
      D: `Gərginliyi hamının qarşısında müzakirəyə çıxarın.`,
    },
    correct: { A: 4, B: 3, C: 1, D: 2 },
    explanation: `A siqnalı oxuyur, anlayır və konstruktiv istifadə edir (4). B siqnalı tanıyır və müşahidə edir, lakin hələ istifadə etmir (3). D siqnalı oxuyur, lakin ictimai şəkildə gündəmə gətirir, bu, münasibətə zərər verə bilər (2). C siqnalı tamamilə susdurur, prinsipi birbaşa pozur (1).`,
  },
  {
    id: 'ez-l2-q1', course: 'ez', lesson_number: 2, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `E-poçt sizi qıcıqlandırır və dərhal kəskin cavab yazmaq istəyirsiniz. Stimul ilə reaksiya arasındakı məsafəni görmək prinsipinə uyğun ən effektiv davranış hansıdır?`,
    options: {
      A: `Dərhal kəskin cavabı yazıb göndərin, çünki haqlısınız.`,
      B: `E-poçtu tamamilə görməzdən gəlin və heç vaxt cavab verməyin.`,
      C: `Bir an dayanın, hansı emosiyanı yaşadığınızı müəyyən edin və cavabı sakitləşdikdən sonra yazın.`,
      D: `Cavabı başqasına yazdırın ki, məsuliyyət sizdə olmasın.`,
    },
    correct: 'C',
    explanation: `Stimul ilə reaksiya arasında bir məsafə var. Bu məsafəni görmək özünüdərkin əsasıdır. C həmin məsafədən istifadə edir: dayanmaq, emosiyanı tanımaq, sonra reaksiya vermək. A məsafəni sıfıra endirir. B məsələni susdurur, həll etmir. D məsuliyyətdən qaçır.`,
  },
  {
    id: 'ez-l2-q2', course: 'ez', lesson_number: 2, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bir vəziyyət sizdə "narahatlıq" adlandırdığınız ümumi hiss yaradır. Emosiyaların adını dəqiq qoymaq prinsipi niyə vacibdir?`,
    options: {
      A: `Çünki dəqiq adlandırma emosiyanı zəiflədir.`,
      B: `Çünki emosiyanı dəqiq adlandırmaq onun mənbəyini və lazımi reaksiyanı aydınlaşdırır.`,
      C: `Çünki adlandırma yalnız psixoloqlar üçün lazımdır.`,
      D: `Çünki emosiyaları adlandırmaq onları gizlətməyə kömək edir.`,
    },
    correct: 'B',
    explanation: `Emosiyanı dəqiq adlandırmaq onu idarə edilə bilən məlumat formasına çevirir. "Narahatlıq" əslində qorxu, məyusluq və ya təzyiq ola bilər və hər biri fərqli reaksiya tələb edir. B bunu izah edir. A və D yanlışdır, adlandırma nə emosiyanı sadəcə zəiflədir, nə də gizlədir. C adlandırmanı yersiz şəkildə məhdudlaşdırır.`,
  },
  {
    id: 'ez-l2-q3', course: 'ez', lesson_number: 2, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bir layihədə səhvə yol verdiniz. Daxili səsiniz sizi davamlı olaraq sərt şəkildə tənqid edir. Özünüdərk ilə özünütənqid arasındakı fərqi nəzərə alaraq ən sağlam yanaşma hansıdır?`,
    options: {
      A: `Səhvi obyektiv qiymətləndirin, nəyin və niyə baş verdiyini anlayın və dərs çıxarın.`,
      B: `Özünüzü davamlı tənqid edin ki, gələcəkdə səhv etməyəsiniz.`,
      C: `Səhvi tamamilə inkar edin, çünki düşünmək narahatlıq yaradır.`,
      D: `Məsuliyyəti başqasına yükləyin.`,
    },
    correct: 'A',
    explanation: `Özünüdərk özünü tənqid etmək deyil. Məqsəd obyektiv anlamaq və inkişaf etməkdir. A bunu edir. B davamlı sərt özünütənqiddir, sağlam deyil və performansı zəiflədə bilər. C inkardır, özünüdərkə ziddir. D məsuliyyətdən qaçır.`,
  },
  {
    id: 'ez-l2-q4', course: 'ez', lesson_number: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Gərgin bir söhbətdən sonra güclü emosiya hiss edirsiniz. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Emosiyanı hiss etdiyinizi qəbul edin, lakin bir az gözləyib sonra düşünün.`,
      B: `Yaşadığınız emosiyanı müəyyən edin, adını qoyun və ona uyğun ölçülü reaksiya seçin.`,
      C: `Emosiyanı dərhal, idarəsiz şəkildə ifadə edin.`,
      D: `Emosiyanın olmadığını özünüzə deyin.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `B stimul-reaksiya məsafəsini istifadə edir, emosiyanı adlandırır və ölçülü reaksiya seçir (ən effektiv). C məsafəni sıfıra endirir, idarəsiz reaksiya verir (ən az effektiv). A qismən doğrudur, gözləmə faydalıdır. D isə inkardır, lakin C qədər zərərli deyil.`,
  },
  {
    id: 'ez-l2-q5', course: 'ez', lesson_number: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Geri bildirim sizi incidir. Aşağıdakı davranışları özünüdərk prinsiplərinə uyğunluğuna görə ən effektivdən ən az effektivə doğru sıralayın.`,
    options: {
      A: `İncikliyi tamamilə susdurun və geri bildirimi unutmağa çalışın.`,
      B: `İncikliyi fərq edin, adını qoyun, sonra geri bildirimin məzmununu obyektiv qiymətləndirin.`,
      C: `İncikliyi fərq edin, lakin emosiya sakitləşmədən dərhal reaksiya verin.`,
      D: `Geri bildirimi verən şəxsi fərdi olaraq qınayın.`,
    },
    correct: ['B', 'C', 'A', 'D'],
    explanation: `B emosiyanı tanıyır, adlandırır və obyektiv qiymətləndirir (ən effektiv). C emosiyanı tanıyır, lakin məsafə yaratmadan reaksiya verir. A emosiyanı susdurur, məlumatı itirir. D emosiyanı şəxsi hücuma çevirir (ən az effektiv).`,
  },
  {
    id: 'ez-l2-q6', course: 'ez', lesson_number: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Stressli gündə özünüzü gərgin hiss edirsiniz. Aşağıdakı davranışların hər birini özünüdərk baxımından 1 (ən az sağlam) ilə 4 (ən sağlam) arasında qiymətləndirin.`,
    options: {
      A: `Gərginliyi müəyyən edin, mənbəyini müəyyən edin və qısa fasilə ilə tənzimləyin.`,
      B: `Gərginliyi qəbul edin, lakin heç bir addım atmadan davam edin.`,
      C: `Özünüzü gərginlik hiss etdiyinizə görə sərt şəkildə qınayın.`,
      D: `Gərginliyin olmadığını özünüzə təlqin edin.`,
    },
    correct: { A: 4, B: 3, C: 1, D: 2 },
    explanation: `A emosiyanı tanıyır, anlayır və tənzimləyir (4). B tanıyır, lakin istifadə etmir (3). D inkardır, məlumatı gizlədir (2). C özünütənqiddir. Özünüdərkə zidd işləyir və ən az sağlamdır (1).`,
  },
  {
    id: 'ez-l3-q1', course: 'ez', lesson_number: 3, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Uşaq bağçasında həmkarınız Ülviyyə bir valideynlə gərgin söhbətdən sonra çox narahatdır. Empatiya göstərmək üçün ən effektiv ilk addım hansıdır?`,
    options: {
      A: `Özünüzü onun yerinə qoyaraq vəziyyəti onun gözündən görməyə çalışın.`,
      B: `Dərhal "narahat olma, keçər" deyin.`,
      C: `Ona nə etməli olduğunu sadalayın.`,
      D: `Mövzunu dəyişib başqa işdən danışın.`,
    },
    correct: 'A',
    explanation: `Empatiya perspektiv almaqla başlayır. A vəziyyəti qarşı tərəfin gözündən görür. B hissi kiçildir və söhbəti bağlayır. C tələsik həll empatiyanı əvəz edə bilməz. D hissi tamamilə yan keçir.`,
  },
  {
    id: 'ez-l3-q2', course: 'ez', lesson_number: 3, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Baytar klinikasında həmkarınız çətin bir gün keçirdiyini danışır. Ən effektiv reaksiya hansıdır?`,
    options: {
      A: `Dərhal həll yolları sadalayın.`,
      B: `Sözünü kəsmədən dinləyin və hissini qəbul etdiyinizi bildirin.`,
      C: `"Bu, o qədər də pis deyil" deyin.`,
      D: `Öz daha çətin gününüzü danışmağa başlayın.`,
    },
    correct: 'B',
    explanation: `Empatiya çox vaxt həll etməklə yox, dinləməklə göstərilir. B dinləyir və hissi təsdiqləyir. A tələsik həll hissi anlama mərhələsini atlayır. C hissi dəyərsizləşdirir. D diqqəti özünüzə çəkir.`,
  },
  {
    id: 'ez-l3-q3', course: 'ez', lesson_number: 3, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Yaxın həmkarınız ağır şəxsi problemini danışır və siz çox təsirlənirsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Onun emosiyasına o qədər qapılın ki, özünüz də işləyə bilməyəsiniz.`,
      B: `Hisslərini tamamilə nəzərə almayın.`,
      C: `Ona dəstək olun, lakin obyektivliyinizi və emosional sərhədinizi qoruyun.`,
      D: `Söhbətdən büsbütün qaçın.`,
    },
    correct: 'C',
    explanation: `Sağlam empatiya həddən artıq affektiv olmamalıdır. C dəstək verir, eyni zamanda sərhədi qoruyur, beləcə faydalı qala bilir. A həddən artıq qapılmaqdır, dəstək imkanını itirir. B empatiyanın yoxluğudur. D qaçmaqdır.`,
  },
  {
    id: 'ez-l3-q4', course: 'ez', lesson_number: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bir həmkarınız narahatlığını paylaşır. Empatiya göstərmək üçün ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Qarşı tərəfə dərhal nə etməli olduğunu deyin.`,
      B: `Hissini qismən qeyd edib mövzunu bağlayın.`,
      C: `Diqqətlə dinləyin, nöqteyi-nəzərini anlayıb hissini adlandırın.`,
      D: `Söhbəti tez bitirib işə qayıdın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Empatiya dinləmək və hissi anlamaqdır. C ən effektivdir. A ən az effektivdir: tələsik həll təklif etmək hissi anlama mərhələsini atlayır. B səthidir, D isə söhbəti yarımçıq kəsir.`,
  },
  {
    id: 'ez-l3-q5', course: 'ez', lesson_number: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Empatiya göstərmə addımlarını ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Qarşı tərəfin nöqteyi-nəzərini anlamağa çalışın.`,
      B: `Hissini adlandırıb qəbul edin.`,
      C: `Lazım olduqda dəstək təklif edin.`,
      D: `Söhbəti tələsik hazır həllinizlə bağlayın.`,
    },
    correct: ['A', 'B', 'C', 'D'],
    explanation: `Empatiya ardıcıllığı: əvvəlcə A perspektivi anlamaq, sonra B hissi adlandırmaq, sonra C dəstək təklif etmək. D ən az effektivdir, çünki tələsik həll qarşı tərəfin hələ anlaşılmadığını hiss etdirir.`,
  },
  {
    id: 'ez-l3-q6', course: 'ez', lesson_number: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Həmkarınız kədərlidir və problemini paylaşır. Aşağıdakı reaksiyaları effektivlik baxımından qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `"Bunu unut, böyük məsələ deyil" deyin.`,
      B: `Diqqətlə dinləyib hissini qəbul edin.`,
      C: `Dərhal həll təklif edin.`,
      D: `Özünüzü onun yerinə qoymağa çalışın və anladığınızı bildirin.`,
    },
    correct: { A: 1, B: 4, C: 2, D: 3 },
    explanation: `Empatiyada dinləmək və perspektiv almaq ən dəyərlidir. B (dinləmə və qəbul) ən güclüdür, D (perspektiv almaq) ona yaxın səviyyədədir. C (tələsik həll) orta səviyyədədir. A hissi dəyərsizləşdirir, ən zəifdir.`,
  },
  {
    id: 'ez-l4-q1', course: 'ez', lesson_number: 4, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Gül mağazasında müştəri sakit səslə danışır, lakin üz ifadəsi və duruşu narahatlıq bildirir. Emosiyasını düzgün qavramaq üçün ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Yalnız sözlərinə əsaslanıb hər şeyin qaydasında olduğunu düşünün.`,
      B: `Yalnız üz ifadəsinə baxıb qəti nəticə çıxarın.`,
      C: `Heç bir siqnala diqqət etməyin.`,
      D: `Söz, səs, üz və duruş kimi bir neçə kanalı və konteksti birlikdə nəzərə alın.`,
    },
    correct: 'D',
    explanation: `Emosiyanı qavramaq çoxkanallıdır. D bir neçə siqnalı və konteksti birləşdirir. A yalnız sözə baxır, qeyri-verbal siqnalı qaçırır. B tək kanala əsaslanır. C siqnalları tamamilə görməzdən gəlir.`,
  },
  {
    id: 'ez-l4-q2', course: 'ez', lesson_number: 4, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Dil məktəbində tələbə "hər şey yaxşıdır" deyir, lakin səsi titrəyir və gözünü yayındırır. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Söz ilə qeyri-verbal siqnal arasındakı uyğunsuzluğu görüb mehribanca dəqiqləşdirin.`,
      B: `Yalnız sözünə inanıb keçin.`,
      C: `Onu yalan danışmaqda ittiham edin.`,
      D: `Heç nə soruşmadan öz qəti nəticənizi çıxarın.`,
    },
    correct: 'A',
    explanation: `Verbal və qeyri-verbal siqnal uyğunsuzluğu mühüm məlumatdır. A uyğunsuzluğu görüb mülayim şəkildə dəqiqləşdirir. B siqnalı görməzdən gəlir. C ittiham münasibəti zədələyir. D dəqiqləşdirmədən hökm verir.`,
  },
  {
    id: 'ez-l4-q3', course: 'ez', lesson_number: 4, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Həmkarınız bir görüşdə qaşqabaqlı görünür. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Dərhal "məndən küsüb" deyə qəti nəticə çıxarın.`,
      B: `Tək bir əlamətdən qəti hökm verməyin, əlavə kontekst və siqnal axtarın.`,
      C: `Onu narahat edən nəsə etdiyinizi düşünüb dərhal üzr istəyin.`,
      D: `Münasibəti azaldın.`,
    },
    correct: 'B',
    explanation: `Tək əlamət çox vaxt aldadıcı olur; bir əlamətə əsasən tələsik nəticə çıxarmaq olmaz. B əlavə kontekst axtarır. A və C bir əlamətdən qəti, çox güman yanlış nəticə çıxarır. D münasibəti əsassız zədələyir.`,
  },
  {
    id: 'ez-l4-q4', course: 'ez', lesson_number: 4, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bir nəfərin əhvalını oxumağa çalışırsınız. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Bir neçə siqnalı və konteksti birlikdə qiymətləndirin.`,
      B: `Yalnız səs tonuna baxın.`,
      C: `Yalnız sözlərə baxın.`,
      D: `Tək bir jestə əsaslanıb qəti nəticə çıxarın.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Çoxkanallı qavrama prinsipi. A ən effektivdir: bir neçə siqnal və kontekst. D ən az effektivdir: tək jestdən qəti hökm həddən artıq oxumaqdır. B və C tək kanala bağlanır, natamamdır.`,
  },
  {
    id: 'ez-l4-q5', course: 'ez', lesson_number: 4, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Bir nəfərin emosiyasını dəqiq qavramaq addımlarını ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Tək siqnaldan qəti hökm verin.`,
      B: `Lazım olsa mehribanca dəqiqləşdirin.`,
      C: `Bir neçə kanaldan siqnalları müşahidə edin.`,
      D: `Konteksti nəzərə alıb ehtimalları qiymətləndirin.`,
    },
    correct: ['C', 'D', 'B', 'A'],
    explanation: `Dəqiq qavrama ardıcıllığı: əvvəlcə C bir neçə kanalı müşahidə et, sonra D konteksti qiymətləndir, sonra B lazım olsa dəqiqləşdir. A ən az effektivdir, çünki tək siqnaldan qəti hökm həddən artıq oxumaqdır.`,
  },
  {
    id: 'ez-l4-q6', course: 'ez', lesson_number: 4, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Bir həmkarın əhvalını oxumağa çalışırsınız. Aşağıdakı yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Söz, səs və üz ifadəsini birlikdə nəzərə alın.`,
      B: `Yalnız sözlərinə əsaslanın.`,
      C: `Kontekstə baxıb ehtimalları qiymətləndirin.`,
      D: `Tək bir jestdən qəti nəticə çıxarın.`,
    },
    correct: { A: 4, B: 2, C: 3, D: 1 },
    explanation: `Çoxkanallı və kontekstli qavrama ən dəqiqdir. A (bir neçə kanal) ən güclüdür, C (kontekst) ona yaxındır. B (yalnız söz) natamamdır. D (tək jestdən qəti hökm) ən zəif və ən aldadıcıdır.`,
  },
  {
    id: 'ez-l5-q1', course: 'ez', lesson_number: 5, topic: 'ez',
    q_type: 'facial',
    svg_question: `<img src="https://swxxutvpafwxwzrtwzjd.supabase.co/storage/v1/object/public/faces/happiness.png" alt="Sifət ifadəsi" style="max-width:280px;width:100%;border-radius:12px;display:block;margin:0 auto" />`, is_free: false, points: 1,
    question_az: `Üzdə ağız küncləri yuxarı qalxıb. Eyni zamanda göz ətrafında qırışlar (qarğa ayağı) görünür və yanaqlar yuxarı qalxıb. Bu üz ifadəsi ən çox hansı vəziyyəti göstərir?`,
    options: {
      A: `Nəzakət gülüşü (yalnız ağız hərəkət edir).`,
      B: `Həqiqi sevinc, yəni Duchenne (səmimi) gülüşü.`,
      C: `Təəccüb.`,
      D: `Gizli narahatlıq.`,
    },
    correct: 'B',
    svg_options: {
      A: ``,
      B: ``,
      C: ``,
      D: ``,
    },
    explanation: `Duchenne (səmimi) gülüşündə həm zygomaticus major (ağız küncləri), həm orbicularis oculi (göz ətrafı) aktivdir. Göz ətrafında qarğa ayağı yaranır və yanaqlar qalxır. Orbicularis oculi-nin göz ətrafı hissəsi ixtiyarsızdır, ona görə həqiqi sevinc göstəricisidir. A yalnız ağız hərəkəti ilə nəzakət gülüşüdür. C və D bu əzələ nümunəsi ilə uyğun gəlmir. Real həyatda emosiyalar daha qarışıq görünə bilər. Ona görə üz ifadəsi, səs tonu, sözlərin məzmunu və situasiya birlikdə qiymətləndirilməlidir.`,
  },
  {
    id: 'ez-l5-q2', course: 'ez', lesson_number: 5, topic: 'ez',
    q_type: 'facial',
    svg_question: `<img src="https://swxxutvpafwxwzrtwzjd.supabase.co/storage/v1/object/public/faces/fear.png" alt="Sifət ifadəsi" style="max-width:280px;width:100%;border-radius:12px;display:block;margin:0 auto" />`, is_free: false, points: 1,
    question_az: `Üzdə qaşlar yuxarı qalxıb, gözlər geniş açılıb, ağız bir az açıqdır. Eyni zamanda qaşlar bir-birinə doğru da çəkilib və qaşlar arasında şaquli xətt yaranıb. Bu üz ifadəsi ən çox hansı emosiyanı göstərir?`,
    options: {
      A: `Sevinc.`,
      B: `İyrənmə.`,
      C: `Təəccüb.`,
      D: `Qorxu.`,
    },
    correct: 'D',
    svg_options: {
      A: ``,
      B: ``,
      C: ``,
      D: ``,
    },
    explanation: `Qorxu ilə təəccüb oxşardır: hər ikisində frontalis lateral aktivdir (qaşlar yuxarı), gözlər açılır. Fərqləndirici element korrugatordur: qorxuda qaşlar eyni anda bir-birinə doğru da çəkilir (şaquli xətt), təəccübdə isə yalnız yuxarı qalxır. Şaquli xətt korrugator aktivləşməsini, yəni qorxunu göstərir. Buna görə C (təəccüb) deyil, D doğrudur. A və B bu nümunə ilə uyğun deyil. Real həyatda emosiyalar daha qarışıq görünə bilər. Ona görə üz ifadəsi, səs tonu, sözlərin məzmunu və situasiya birlikdə qiymətləndirilməlidir.`,
  },
  {
    id: 'ez-l5-q3', course: 'ez', lesson_number: 5, topic: 'ez',
    q_type: 'facial',
    svg_question: `<img src="https://swxxutvpafwxwzrtwzjd.supabase.co/storage/v1/object/public/faces/disgust.png" alt="Sifət ifadəsi" style="max-width:280px;width:100%;border-radius:12px;display:block;margin:0 auto" />`, is_free: false, points: 1,
    question_az: `Üzdə burun kökü qırışıb, üst dodaq yuxarı qalxıb və burun bir az yuxarı çəkilmiş kimi görünür. Bu üz ifadəsi ən çox hansı emosiyanı göstərir?`,
    options: {
      A: `İyrənmə.`,
      B: `Qəzəb.`,
      C: `Kədər.`,
      D: `Təəccüb.`,
    },
    correct: 'A',
    svg_options: {
      A: ``,
      B: ``,
      C: ``,
      D: ``,
    },
    explanation: `Qəzəb ilə iyrənmə hər ikisi neqativ və intensivdir, lakin fərqlənir. İyrənmədə burun kökü qırışır və üst dodaq qalxır (levator labii aktivləşməsi). Qəzəbdə isə korrugator aktivdir, qaşlar aşağı sürüşür, dodaqlar sıxılır. Burun qırışığı və üst dodağın qalxması iyrənmə göstəricisidir, ona görə A doğrudur. B qəzəbə xas alın və dodaq nümunəsini göstərmir. Real həyatda emosiyalar daha qarışıq görünə bilər. Ona görə üz ifadəsi, səs tonu, sözlərin məzmunu və situasiya birlikdə qiymətləndirilməlidir.`,
  },
  {
    id: 'ez-l5-q4', course: 'ez', lesson_number: 5, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bir görüşdə qarşı tərəf gülümsəyir, lakin gözlərində heç bir qırış yoxdur və yanaqları qalxmır. Yalnız ağız gülüşünə baxıb "razıdır" nəticəsinə gəlmək niyə risklidir?`,
    options: {
      A: `Çünki ağız gülüşü heç vaxt sevinc göstərmir.`,
      B: `Çünki gülüş hər zaman gizli qəzəb deməkdir.`,
      C: `Çünki gülüş yalnız mədəni normadır və heç bir məlumat daşımır.`,
      D: `Çünki göz ətrafı hərəkət olmadan bunun nəzakət gülüşü, yəni performativ ola biləcəyini söyləmək olar. Həqiqi sevinc göz ətrafında da görünür.`,
    },
    correct: 'D',
    explanation: `Yalnız ağız gülüşünə fokuslanmaq geniş yayılmış tələdir. Həqiqi sevincdə (Duchenne, səmimi) göz ətrafı orbicularis oculi də aktivdir. Bu hissə ixtiyarsızdır və könüllü təqlidi çətindir. Göz ətrafında hərəkət olmadıqda gülüşün nəzakət, yəni performativ ola biləcəyini ehtimal etmək lazımdır. A və B həddindən artıq qəti nəticələrdir. C gülüşün məlumat daşımadığını yanlış iddia edir.`,
  },
  {
    id: 'ez-l5-q5', course: 'ez', lesson_number: 5, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bir həmkarınızın qaşları çatılıb. Dərhal "deməli qəzəblidir" nəticəsinə gəlmək niyə əsassız ola bilər?`,
    options: {
      A: `Çünki qaşların çatılması heç vaxt emosiya göstərmir.`,
      B: `Çünki korrugator aktivləşməsi kədər, narahatlıq, ciddiyyət və konsentrasiya zamanı da baş verir. Kontekst olmadan tək bir emosiya nəticəsi çıxarmaq olmaz.`,
      C: `Çünki yalnız gözlər emosiya göstərir, qaşlar yox.`,
      D: `Çünki qaşların çatılması yalnız təəccüb deməkdir.`,
    },
    correct: 'B',
    explanation: `Bir əzələ aktivləşməsindən tək bir emosiya nəticəsi çıxarmaq tələdir. Korrugator (qaşların çatılması) kədər, narahatlıq, ciddiyyət, konsentrasiya zamanı da işləyir. B bunu izah edir və kontekstin vacibliyini vurğulayır. A yanlışdır, qaş hərəkəti məlumat daşıyır. C səhvdir, qaşlar da məlumat verir. D korrugatoru səhv olaraq təəccüblə eyniləşdirir.`,
  },
  {
    id: 'ez-l5-q6', course: 'ez', lesson_number: 5, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Sakit görünən bir söhbətdə qarşı tərəfin üzündə saniyənin çox kiçik hissəsi qədər davam edən və dərhal itən ifadə yaranır. Bu hadisə nədir və niyə vacibdir?`,
    options: {
      A: `Bu sadəcə əzələ yorğunluğudur, heç bir məna daşımır.`,
      B: `Bu mikroifadədir. Çox vaxt ixtiyarsızdır və gizlədilmək istənən emosiyanı sızdıra bilər, ona görə vacib məlumat daşıyır.`,
      C: `Bu nəzakət gülüşünün bir növüdür.`,
      D: `Bu yalnız kameralarda görünən texniki effektdir.`,
    },
    correct: 'B',
    explanation: `Mikroifadə saniyənin çox kiçik hissəsində keçən, çox vaxt ixtiyarsız yaranan üz ifadəsidir. Şəxs gizlətmək istəsə belə qarşısını almaq çətindir. Buna görə xüsusilə formal, sakit kontekstlərdə dəyərli məlumat daşıyır. A və D mikroifadəni səhv izah edir. C onu gülüşlə qarışdırır.`,
  },
  {
    id: 'ez-l6-q1', course: 'ez', lesson_number: 6, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Hotel resepsiyasında sakit və diqqətli əhval-ruhiyyədəsiniz. Qarşınızda həm detallı hesabat yoxlaması, həm də enerji tələb edən müştəri qarşılaması var. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Əhvalınızı nəzərə almadan təsadüfi bir işə başlayın.`,
      B: `Ən çox enerji tələb edən işi indi seçin.`,
      C: `Sakit, diqqətli əhvalınıza uyğun olan detallı yoxlama işini indi görün.`,
      D: `Heç bir işə başlamayın.`,
    },
    correct: 'C',
    explanation: `Sakit, diqqətli əhval detallı işə uyğundur. C əhvalı tapşırığa uyğunlaşdırır. A əhvalı nəzərə almır. B əhvalına uyğun olmayan iş seçir. D passivdir.`,
  },
  {
    id: 'ez-l6-q2', course: 'ez', lesson_number: 6, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Komanda rəhbərisiniz və bu gün gərginsiniz. Bilirsiniz ki, əhvalınız komandaya təsir edir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Gərginliyinizi olduğu kimi komandaya yansıtın.`,
      B: `Hisslərinizi tamamilə gizlədib heç nə hiss etmədiyinizi deyin.`,
      C: `Gərginliyə görə komandanı günahlandırın.`,
      D: `Öz əhvalınızı tənzimləyin, çünki emosiyalar komandaya yoluxur.`,
    },
    correct: 'D',
    explanation: `Liderin əhvalı komandaya keçir (emosional yoluxma). D əhvalı tənzimləyib müsbət təsir yaradır. A variantı mənfi əhvalı yayır. B variantında inkar tənzimləmə deyil. C variantı məsuliyyəti komandaya yükləyir.`,
  },
  {
    id: 'ez-l6-q3', course: 'ez', lesson_number: 6, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bir layihədə səbəbi aydın olmayan narahatlıq hiss edirsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Narahatlığı siqnal kimi qəbul edib diqqətinizi mümkün riskə və ya nəzərdən qaçan detala yönəldin.`,
      B: `Narahatlığı tamamilə susdurun.`,
      C: `Narahatlığa görə layihəni dayandırın.`,
      D: `Hissi başqalarının üstünə yönəldin.`,
    },
    correct: 'A',
    explanation: `Emosiya diqqəti yönəldən məlumatdır. A narahatlığı siqnal kimi oxuyub faydalı istiqamətə çevirir. B məlumatı itirir. C həddən artıq reaksiyadır. D hissi məsuliyyətsiz şəkildə yönəldir.`,
  },
  {
    id: 'ez-l6-q4', course: 'ez', lesson_number: 6, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Komanda rəhbəri kimi öz əhvalınızı idarə edirsiniz. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Əhvalınızı görüləcək tapşırığa uyğunlaşdırın.`,
      B: `Mənfi əhvalınızı idarə etmədən komandaya ötürün.`,
      C: `Hisslərinizi tamamilə gizlədin.`,
      D: `Əhvalınızı tənzimləyib müsbət ab-hava yaradın, çünki o, komandaya keçir.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Emosional yoluxma və tənzimləmə prinsipi. D ən effektivdir: əhvalı tənzimləyib müsbət təsir yaradır. B ən az effektivdir: idarə olunmamış mənfi əhval komandaya yoluxur. A faydalıdır, C isə gizlətmə real tənzimləmə deyil.`,
  },
  {
    id: 'ez-l6-q5', course: 'ez', lesson_number: 6, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Emosiyadan məhsuldar istifadə addımlarını ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hissi tamamilə görməzdən gəlin.`,
      B: `Hissi siqnal kimi oxuyun.`,
      C: `Hissin işarə etdiyi məsələyə diqqətinizi yönəldin.`,
      D: `Əhvalınızı görüləcək tapşırığa uyğunlaşdırın.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `Emosiyadan istifadə ardıcıllığı: əvvəlcə B (hissi siqnal kimi oxumaq), sonra C (onun işarə etdiyi məsələyə diqqət yönəltmək), sonra D (əhvalı tapşırığa uyğunlaşdırmaq). A ən az effektivdir, çünki hissi görməzdən gəlmək faydalı məlumatı itirir.`,
  },
  {
    id: 'ez-l6-q6', course: 'ez', lesson_number: 6, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Vacib təqdimatdan əvvəl həyəcanlısınız. Aşağıdakı yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Həyəcanı hazırlığa diqqət yönəltmək üçün istifadə edin.`,
      B: `Həyəcanı inkar edib heç nə hiss etmədiyinizi deyin.`,
      C: `Həyəcanı tanıyıb enerjiyə çevirin və hazırlığınızı nəzərdən keçirin.`,
      D: `Həyəcana görə təqdimatı təxirə salın.`,
    },
    correct: { A: 3, B: 1, C: 4, D: 2 },
    explanation: `Həyəcan düzgün istifadə edildikdə faydalı enerjiyə çevrilir. C (tanıyıb enerjiyə çevirmək) ən güclüdür, A (diqqət üçün istifadə) ona yaxın səviyyədədir. D (təxirə salmaq) qaçışdır, orta-zəif yanaşmadır. B (inkar) ən zəifdir, çünki məlumatı itirir.`,
  },
  {
    id: 'ez-l7-q1', course: 'ez', lesson_number: 7, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Çox əsəbisiniz və dərhal sərt bir mesaj yazmaq istəyirsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Mesajı dərhal yazıb göndərin.`,
      B: `Emosiyanın zirvəsinin keçəcəyini nəzərə alıb bir az gözləyin, sonra sakit yazın.`,
      C: `Heç vaxt cavab verməyin.`,
      D: `Əsəbinizi başqasından çıxın.`,
    },
    correct: 'B',
    explanation: `Emosiyalar inkişaf edir: yaranır, zirvəyə çatır, sakitləşir. B zirvənin keçməsini gözləməkyib sakit qərar verir. A zirvədə hərəkət etmək ciddi səhvə yol aça bilər. C ifrat qaçışdır. D hissi yanlış istiqamətə yönəldir.`,
  },
  {
    id: 'ez-l7-q2', course: 'ez', lesson_number: 7, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Karyera irəliləyişi üçün başqa şəhərə köçürsünüz: həm sevincli, həm narahatsınız. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Yalnız sevinci qəbul edib narahatlığı inkar edin.`,
      B: `Yalnız narahatlığa fokuslanıb sevinci unudun.`,
      C: `Hər iki hissin eyni anda mövcud ola biləcəyini qəbul edin.`,
      D: `Hisslərinizi tamamilə susdurun.`,
    },
    correct: 'C',
    explanation: `Ziddiyyətli hisslər eyni anda mövcud ola bilər. C bunu qəbul edir, real mənzərəni saxlayır. A və B hisslərin yalnız birini görür. D bütün hissləri susdurur, məlumatı itirir.`,
  },
  {
    id: 'ez-l7-q3', course: 'ez', lesson_number: 7, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Günün sonunda səbəbi aydın olmayan əsəbilik hiss edirsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Əsəbiliyi yaxınlarınızdan çıxarın.`,
      B: `Hissi tamamilə görməzdən gəlin.`,
      C: `Özünüzü bu hissə görə tənqid edin.`,
      D: `Hissi nəyin tətiklədiyini, hansı hadisədən başladığını izləyin.`,
    },
    correct: 'D',
    explanation: `Hisslərin bir tətikləyicisi və başlanğıcı olur. D mənbəyi izləyib anlamağa çalışır. A hissi yanlış istiqamətə yönəldir. B məlumatı itirir. C özünütənqid anlamağı əvəz etmir.`,
  },
  {
    id: 'ez-l7-q4', course: 'ez', lesson_number: 7, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Güclü hiss anında ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hissi dərhal, olduğu kimi davranışa çevirin.`,
      B: `Hissin keçici olduğunu bilib sakitləşənə qədər gözləyin, sonra qərar verin.`,
      C: `Hissi tamamilə inkar edib yoxmuş kimi davranın.`,
      D: `Hissi başqasının üstünə yönəldin.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Emosiyanın inkişaf dinamikasını anlama prinsipi. B ən effektivdir: zirvənin keçməsini gözləməkyib qərar verir. C ən az effektivdir: hissi tamamilə inkar etmək onun verdiyi məlumatı itirir. A zirvədə hərəkət etməkdir, D isə hissi yanlış istiqamətə yönəldir.`,
  },
  {
    id: 'ez-l7-q5', course: 'ez', lesson_number: 7, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Bir emosiyanı anlamaq addımlarını ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hissi dərhal kortəbii davranışa çevirin.`,
      B: `Hissin zirvəsinin keçəcəyini gözləyin.`,
      C: `Hissin məqsədini, nəyə işarə etdiyini anlayın.`,
      D: `Hissi nəyin tətiklədiyini müəyyən edin.`,
    },
    correct: ['D', 'C', 'B', 'A'],
    explanation: `Emosiyanı anlamaq ardıcıllığı: əvvəlcə D tətikləyicini müəyyən et, sonra C məqsədini anlamaq, sonra B zirvənin keçməsini gözləmək. A ən az effektivdir, çünki kortəbii hərəkət hissi anlamağı tamamilə atlayır.`,
  },
  {
    id: 'ez-l7-q6', course: 'ez', lesson_number: 7, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Gözlənilməz xəbərdən sonra qarışıq hisslər keçirirsiniz. Aşağıdakı yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Yalnız bir hissi seçib qalanını inkar edin.`,
      B: `Hisslərin keçici ola biləcəyini xatırlayıb bir az gözləyin.`,
      C: `Hisslərinizi tamamilə susdurun.`,
      D: `Hisslərinizi adlandırıb nəyin tətiklədiyini anlayın.`,
    },
    correct: { A: 2, B: 3, C: 1, D: 4 },
    explanation: `Emosiyanı anlamaq onları adlandırmaq və mənbəyini müəyyən etməklə başlayır. D ən güclüdür, B (keçiciliyi xatırlamaq) ona yaxındır. A (yalnız birini qəbul etmək) natamamdır. C (tamamilə bağlamaq) ən zəifdir.`,
  },
  {
    id: 'ez-l8-q1', course: 'ez', lesson_number: 8, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bir müştəri sizinlə kobud davranır və siz əsəbiləşirsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Reaksiya vermədən əvvəl bir an dayanıb nəfəs alın və vəziyyəti yenidən çərçivələyin.`,
      B: `Dərhal eyni kobudluqla cavab verin.`,
      C: `Hisslərinizi tamamilə susduraraq heç nə hiss etmədiyinizi deyin.`,
      D: `Müştərini kobudluqda ittiham edin.`,
    },
    correct: 'A',
    explanation: `Özünütənzimləmə strategiyası: reaksiyadan əvvəl dayan, nəfəs al, yenidən çərçivələ. A bunu edir. B kortəbii reaksiyadır, vəziyyəti pisləşdirir. C susdurmaq tənzimləmə deyil. D münaqişəni böyüdür.`,
  },
  {
    id: 'ez-l8-q2', course: 'ez', lesson_number: 8, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Həmkarınız narahat görünür və problemini sizinlə bölüşür. Ona kömək etməyin ən effektiv yolu hansıdır?`,
    options: {
      A: `Onun problemini tamamilə öz üzərinizə götürərək əvəzinə həll edin.`,
      B: `Ona öz hisslərini anlayıb həll tapmasına kömək edin, lakin məsuliyyəti onda saxlayın.`,
      C: `"Bu, sənin problemindir" deyib uzaqlaşın.`,
      D: `Onun əvəzinə qərar verib icra edin.`,
    },
    correct: 'B',
    explanation: `Başqasına dəstək sahiblənmək deyil, asanlaşdırmaqdır. B kömək edir, lakin məsuliyyəti saxlayır, beləcə onu gücləndirir. A və D problemi sahiblənib onu zəiflədir. C dəstəyin yoxluğudur.`,
  },
  {
    id: 'ez-l8-q3', course: 'ez', lesson_number: 8, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `İki həmkar arasında qızğın mübahisə gedir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Səsinizi qaldırıb hər ikisini susdurun.`,
      B: `Tərəf tutub birini müdafiə edin.`,
      C: `Sakit ton, qəbul edən dil və ortaq zəmin ilə gərginliyi azaldın.`,
      D: `Otaqdan çıxıb məsələni öz axarına buraxın.`,
    },
    correct: 'C',
    explanation: `Sakit ton və ortaq nöqtə gərginliyi azaldır. C bunu edir. A səs qaldırmaq gərginliyi artırır. B tərəf tutmaq münaqişəni dərinləşdirir. D problemi həll etmir.`,
  },
  {
    id: 'ez-l8-q4', course: 'ez', lesson_number: 8, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Güclü emosiya anında onu idarə etmək üçün ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Emosiyanı tənzimləmədən dərhal kəskin reaksiya verin.`,
      B: `Hissi tamamilə gizlədərək davam edin.`,
      C: `Bir an dayanıb tənzimləmə strategiyası (nəfəs, yenidən çərçivələmə) tətbiq edin, sonra cavab verin.`,
      D: `Məsələdən büsbütün qaçın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Özünütənzimləmə prinsipi. C ən effektivdir: dayan, tənzimlə, sonra cavab ver. A ən az effektivdir: idarə olunmamış kəskin reaksiya vəziyyəti pisləşdirir. B gizlətmə real tənzimləmə deyil, D isə qaçışdır.`,
  },
  {
    id: 'ez-l8-q5', course: 'ez', lesson_number: 8, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Güclü emosiyanı həmin anda idarə etmək addımlarını ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Bir an dayanıb nəfəs alın.`,
      B: `Vəziyyəti yenidən çərçivələyin.`,
      C: `Sakit və ölçülü cavab verin.`,
      D: `Dərhal kortəbii reaksiya verin.`,
    },
    correct: ['A', 'B', 'C', 'D'],
    explanation: `Özünütənzimləmə ardıcıllığı: əvvəlcə A (dayanmaq və nəfəs almaq), sonra B (yenidən çərçivələmək), sonra C (ölçülü cavab vermək). D ən az effektivdir, çünki kortəbii reaksiya tənzimləmə mərhələsini tamamilə atlayır.`,
  },
  {
    id: 'ez-l8-q6', course: 'ez', lesson_number: 8, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Gərgin anda öz emosiyanızı idarə edirsiniz. Aşağıdakı yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Bir an dayanıb sakitləşin, sonra cavab verin.`,
      B: `Dərhal kəskin reaksiya verin.`,
      C: `Vəziyyəti yenidən çərçivələyərək ölçülü cavab verin.`,
      D: `Hissi tamamilə susdurub davam edin.`,
    },
    correct: { A: 4, B: 1, C: 3, D: 2 },
    explanation: `Özünütənzimləmədə dayanıb sakitləşmək və vəziyyəti yenidən çərçivələmək ən faydalıdır. A ən güclüdür, C ona yaxındır. D (susdurmaq) qısamüddətli və natamam yanaşmadır. B (kəskin reaksiya) ən zəifdir.`,
  },
  {
    id: 'ez-l9-q1', course: 'ez', lesson_number: 9, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Komanda üzvü səhv edib və çox narahatdır. Həm onun hissini, həm də düzgün qərarı nəzərə almalısınız. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Yalnız onun hissinə fokuslanıb səhvi nəzərdən qaçırın.`,
      B: `Yalnız səhvə fokuslanıb hissini tamamilə unudun.`,
      C: `Qərardan ümumiyyətlə qaçın.`,
      D: `Emosional fərqindəliyi sağlam mühakimə ilə birləşdirin: hissi qəbul edin, eyni zamanda düzgün addımı atın.`,
    },
    correct: 'D',
    explanation: `EZT-SMT körpüsü: emosional fərqindəlik və sağlam mühakimə birlikdə işləyir. D hər ikisini birləşdirir. A yalnız hissə fokuslanaraq düzgün qərarı itirir. B yalnız fakta fokuslanaraq münasibəti zədələyir. C qərardan qaçmaq problemi həll etmir.`,
  },
  {
    id: 'ez-l9-q2', course: 'ez', lesson_number: 9, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Gərgin bir komanda görüşündəsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Görüşün emosional ab-havasını oxuyub ona uyğun effektiv addım seçin.`,
      B: `Ab-havanı nəzərə almadan gündəliyi olduğu kimi davam etdirin.`,
      C: `Yığıncağı dərhal dayandırın.`,
      D: `Gərginliyi daha da artıran sərt ton seçin.`,
    },
    correct: 'A',
    explanation: `EZT tətbiqi: əvvəlcə emosional vəziyyəti oxu, sonra ona uyğun addım seç. A bunu edir. B ab-havaya məhəl qoymur, qərarın effektivliyini azaldır. C həddən artıq reaksiyadır. D gərginliyi qəsdən artırır.`,
  },
  {
    id: 'ez-l9-q3', course: 'ez', lesson_number: 9, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `İki nəfər eyni imkan üçün namizəddir və hər ikisi həssas vəziyyətdədir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `İmkanı daha çox bəyəndiyiniz şəxsə verin.`,
      B: `Hər ikisinin vəziyyətini empatiya ilə anlayıb ədalətli, şəffaf qərar verin.`,
      C: `Qərarı qeyri-müəyyən müddətə təxirə salın.`,
      D: `Seçimi təsadüfə buraxın.`,
    },
    correct: 'B',
    explanation: `EZT-nin tətbiqi empatiyanı ədalətli qərarla birləşdirir. B hər iki tərəfi anlayıb şəffaf qərar verir. A simpatiyaya görə qərar ədalətsizdir. C təxirə salmaq problemi uzadır. D məsuliyyətli qərar deyil.`,
  },
  {
    id: 'ez-l9-q4', course: 'ez', lesson_number: 9, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Həm emosional, həm analitik tərəfi olan bir qərar verirsiniz. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Yalnız emosiyaya əsaslanıb qərar verin.`,
      B: `Yalnız faktlara baxıb insan faktorunu tamamilə unudun.`,
      C: `Qərardan büsbütün qaçın.`,
      D: `Emosional fərqindəliyi və analitik mühakiməni balanslı şəkildə birləşdirin.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `EZT-SMT inteqrasiyası prinsipi. D ən effektivdir: emosional və analitik tərəfləri balanslaşdırır. B ən az effektivdir: insan faktorunu tamamilə unutmaq münasibəti və qəbul edilmə ehtimalını zədələyir. A yalnız emosiyaya söykənir, C isə qərardan qaçır.`,
  },
  {
    id: 'ez-l9-q5', course: 'ez', lesson_number: 9, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Emosional zəkanı sağlam mühakimə ilə tətbiq etməyin addımlarını ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Emosiyanı tamamilə kənara qoyub yalnız faktlara baxın.`,
      B: `Yalnız emosiyaya əsaslanıb qərar verin.`,
      C: `Vəziyyətin emosional tərəfini oxuyun.`,
      D: `Emosional anlayışı sağlam mühakimə ilə birləşdirin.`,
    },
    correct: ['C', 'D', 'B', 'A'],
    explanation: `EZT tətbiqi ardıcıllığı: əvvəlcə C emosional tərəfi oxumaq, sonra D onu sağlam mühakimə ilə birləşdirmək. B (yalnız emosiya) natamamdır. A ən az effektivdir, çünki emosiyanı tamamilə kənara qoymaq insan faktorunu və qəbulu itirir.`,
  },
  {
    id: 'ez-l9-q6', course: 'ez', lesson_number: 9, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Həm hisslərin, həm də faktların rol oynadığı bir qərar verirsiniz. Aşağıdakı yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Yalnız emosiyaya əsaslanın.`,
      B: `Vəziyyətin emosional tərəfini oxuyub nəzərə alın.`,
      C: `Emosional anlayışı sağlam mühakimə ilə birləşdirin.`,
      D: `Yalnız faktlara baxıb insan faktorunu unudun.`,
    },
    correct: { A: 1, B: 3, C: 4, D: 2 },
    explanation: `EZT-nin güclü tətbiqi emosional anlayışı sağlam mühakimə ilə birləşdirir. C ən güclüdür, B (emosional tərəfi oxumaq) ona yaxındır. D (yalnız fakt) insan faktorunu itirir, orta-zəif yanaşmadır. A (yalnız emosiya) ən zəifdir.`,
  },
];